import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import PropTypes from "prop-types"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Label,
  Table,
  // Input,
  Button,
  Input,
  Spinner,
} from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider from "react-bootstrap-table2-toolkit"
import { withRouter } from "react-router-dom"
import Modal from "react-bootstrap/Modal"
import Select from "react-select"
import { useSelector } from "react-redux"
import { connect } from "react-redux"
import * as saveVideoAction from "../../../store/c2F2ZXRoZXZpZGVv/actions"
import * as printAction from "../../../store/c2F2ZXRoZXBob3Rv/actions"
import { isEmpty } from "lodash"
import { ToastContainer, toast } from "react-toastify"
import ButtonSpinner from "components/ButtonSpinner"
import moment from "moment"
import api from "helpers/Api"
import { Link } from "react-router-dom/cjs/react-router-dom.min"
import { ReactSearchAutocomplete } from "react-search-autocomplete"

const SaveTheVideoDetails = (props) => {
  const { dispatch, searchBtnStyle } = props

  const title = "Save The Date (Video)"

  const [downloadLoading, setDownloadLoading] = useState(false)
  const empId = localStorage.getItem("empId")

  //Fetching API
  useEffect(() => {
    dispatch(saveVideoAction.loadRecordsMetaData())
    dispatch(
      saveVideoAction.loadVideoDetails({
        page: 1,
        limit: 50,
        isOperation: true,
        // crmId: empId
      })
    )
  }, [])

  //date format

  const sessionUpdate = useSelector((specificstate) => specificstate.session)
  const { user = [] } = sessionUpdate

  //date format from localstorage
  const authUser = localStorage.getItem("authUser")

  const dateLogin = JSON.parse(authUser)

  const setDate =
    !isEmpty(dateLogin) && dateLogin.setting && dateLogin.setting.dateFormate
      ? dateLogin.setting.dateFormate.toUpperCase()
      : !isEmpty(user) && user.setting && user.setting.dateFormate
        ? user.setting.dateFormate.toUpperCase()
        : []

  const dateFormat = !isEmpty(setDate) && setDate ? setDate : ""

  const update = useSelector((specificstate) => specificstate.savethevideo)

  const { video_details = [], recordsMetaData = {} } = update


  //column checkbox modal

  const [columnModal, setColumnModal] = useState(false)

  //Handle Change

  const [event, setEvent] = useState([])
  //Handle Change
  
  const [btnLoader, setBtnLoader] = useState(false)


  const [videoData, setVideoData] = useState({
    leadNo: "",
    eventFromDate: "",
    eventToDate: "",
    assignedFromDate: "",
    assignedToDate: "",
    brideName: "",
    groomName: "",
  })
  const [ewName, setEwName] = useState([])
  const [deliverableStatus, setDeliverableStatus] = useState([])
 
  const [agentKey, setAgentKey] = useState(false)
  const fuseAgentOptions = {
    keys: ["empCode", "label"],
  }
  const deliverables = !isEmpty(deliverableStatus) && deliverableStatus.map(m => m.value)
  const handleChange = (e) => {
    setVideoData({ ...videoData, [e.target.name]: e.target.value })
  }

  const [productData, setProductData] = useState({
    notes: "",
  })

  const handleNotes = (e) => {
    setProductData({ ...productData, [e.target.name]: e.target.value })
  }

  const [teamData, setTeamData] = useState({
    note: "",
  })

  const handleTeam = (e) => {
    setTeamData({ ...teamData, [e.target.name]: e.target.value })
  }

  const [multiProductEmployee, setMultiProductEmployee] = useState([])
  const [multiTeamEmployee, setMultiTeamEmployee] = useState([])

  const [multiProductData, setMultiProductData] = useState({
    note: "",
  })
  const handleMultiProduct = (e) => {
    setMultiProductData({
      ...multiProductData,
      [e.target.name]: e.target.value,
    })
  }
  const [multiTeamData, setMultiTeamData] = useState({
    note: "",
  })
  const handleMultiTeam = (e) => {
    setMultiTeamData({ ...multiTeamData, [e.target.name]: e.target.value })
  }

  const [pageCount, setPageCount] = useState(false)
  const [btnLoading, setBtnLoading] = useState(false)
  const [pageChange, setPageChange] = useState(false)
  //Search value
  const [searchValueList, setSearchValueList] = useState({})
  const [searchFilter, setSearchFilter] = useState(false)
  const [searchInput, setSearchInput] = useState("")
  const searchValue = !isEmpty(searchValueList) && isEmpty(searchInput)
    ? searchValueList : isEmpty(searchValueList) && isEmpty(searchInput) ?
      {
        page: 1,
        limit: 50,
        isOperation: true,
      } : {
        page: 1,
        limit: 50,
        isOperation: true,
        searchFilter: searchInput
      }
  const handleFilter = (e) => {
    e.preventDefault()
    
    var searchLeadNo = videoData && videoData ? videoData.leadNo : ""

    var searchEvent = event && event ? event.value : ""
    var searchFromDate =
      videoData && videoData.eventFromDate
        ? moment(videoData.eventFromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      videoData && videoData.eventToDate
        ? moment(videoData.eventToDate).format("YYYY-MM-DD")
        : ""
    
    var searchAssignedFromDate =
      videoData && videoData.assignedFromDate
        ? moment(videoData.assignedFromDate).format("YYYY-MM-DD")
        : ""
    var searchAssignedToDate =
      videoData && videoData.assignedToDate
        ? moment(videoData.assignedToDate).format("YYYY-MM-DD")
        : ""
    var searchGroom = videoData && videoData.groomName
      ? videoData.groomName
      : ""
    var searchBride = videoData && videoData.brideName
      ? videoData.brideName
      : ""
    var searchEwName = !isEmpty(ewName) ? [ewName.value] : ""
    var searchDeliverable = !isEmpty(deliverableStatus)
      ? deliverables
      : ""
    var searchvalue = {}
    searchvalue.page = pageChange ? pageCount : 1
    searchvalue.limit = 50
    searchvalue.isOperation = true
    // searchvalue.crmId = empId
    
    if (searchLeadNo) {
      searchvalue.leadNo = searchLeadNo
    }
    if (searchEvent) {
      searchvalue.eventNameId = searchEvent
    }
    if (searchFromDate) {
      searchvalue.eventStartDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.eventEndDate = searchToDate
    }
    
    if (searchAssignedFromDate) {
      searchvalue.assignedFromDate = searchAssignedFromDate
    }
    if (searchAssignedToDate) {
      searchvalue.assignedToDate = searchAssignedToDate
    }
    if (searchGroom) {
      searchvalue.groomName = searchGroom
    }
    if (searchBride) {
      searchvalue.brideName = searchBride
    }
    if (searchEwName) {
      searchvalue.assignedEmployeeId = searchEwName
    }
    if (searchDeliverable) {
      searchvalue.productionprocessstatus = searchDeliverable
    }
    setSearchValueList(searchvalue)
    setPageLoad(!pageLoad)
    setProductAssignDetails([])
    setTeamAssignDetails([])
    dispatch(saveVideoAction.loadVideoDetails(searchvalue))
    setBtnLoader(true)
    setBtnLoading(true)
    setTimeout(() => {
      setBtnLoading(false)
      setBtnLoader(false)
    }, 2000)
  }

  //reset

  const resetForm = () => {
    setEvent([])
    
    setSearchInput("")
    setVideoData({
      ...videoData,
      leadNo: "",
      eventFromDate: "",
      eventToDate: "",
      assignedFromDate: "",
      assignedToDate: "",
      brideName: "",
      groomName: "",

    })
    
    setAgentKey(true)
    setTimeout(() => {
      setAgentKey(false)
    }, 0)
    setDeliverableStatus([])
    setEwName([])
    setSearchValueList({
      page: 1,
      limit: 50,
      isOperation: true,
      // crmId: empId
    })
    setProductAssignDetails([])
    setTeamAssignDetails([])
    dispatch(
      saveVideoAction.loadVideoDetails({
        page: 1,
        limit: 50,
        isOperation: true,
        // crmId: empId
      })
    )
  }

  const [plEmployee, setPlEmployee] = useState([])
  const [employee, setEmployee] = useState([])
  const [teamEmployee, setTeamEmployee] = useState([])
  const [productAssignModal, setProductAssignModal] = useState(false)
  const [teamAssignModal, setTeamAssignModal] = useState(false)

  const [uploadInput, setUploadInput] = useState([])
  const [fileData, setFileData] = useState([])
  const uploadChange = async (e, index, data) => {
    if (e.target.files) {
      setBtnLoading(true)
      setUploadInput(e.target.files)
      var file = e.target.files
      var fileArrayDetails = Array.from(file)
      const updatedFileData = [...fileData]
      // Update the file data for the specific row
      updatedFileData[index] = {
        fileName: file[0].name,
        fileLength: file.length,
      }
      // Update the fileData state with the updated row
      setFileData(updatedFileData)
      var uploadValue = uploadInput

      //post image api call
      for (let x in fileArrayDetails) {
        const formData = new FormData()
        formData.append("file", fileArrayDetails[x])
        api.post("/image_upload", formData).then(async (res) => {
          if (res && res.data && res.data.data) {
            uploadValue.push(res.data.data)
            await setUploadInput(uploadValue)
          }
        })
      }
      setTimeout(() => {
        const tat_details = {
          deliverableId: data.leadDeliverableId,
          productionId: data.oprationId,
          crmAttachments: uploadInput,
        }
        dispatch(saveVideoAction.addTat(tat_details))

        dispatch(saveVideoAction.loadVideoDetails(searchValue))
        setBtnLoading(false)
      }, 1500)
    }
  }

  const [attachmentFile, setAttachmentFile] = useState([])
  const [attachmentData, setAttachmentData] = useState([])

  const attachmentChange = async (e, index) => {
    if (e.target.files) {
      setBtnLoading(true)
      setAttachmentFile(e.target.files)
      var file = e.target.files
      var fileArrayDetails = Array.from(file)
      var uploadValue = attachmentFile
      const updatedAttachmentData = [...attachmentData]

      // Update the file data for the specific row
      updatedAttachmentData[index] = {
        fileName: file[0].name,
        fileLength: file.length,
      }

      // Update the fileData state with the updated row
      setAttachmentData(updatedAttachmentData)
      for (let x in fileArrayDetails) {
        const formData = new FormData()
        formData.append("file", fileArrayDetails[x])
        api.post("/image_upload", formData).then(async (res) => {
          if (res && res.data && res.data.data) {
            uploadValue.push(res.data.data)
            await setAttachmentFile(uploadValue)
          }
        })
      }
      setTimeout(() => {
        setBtnLoading(false)
      }, 1000)
    }
  }

  const handleClearModal = () => {
    setEmployee([])
    setTeamEmployee([])
    setMultiProductEmployee([])
    setMultiTeamEmployee([])
    setProductData({ ...productData, notes: "" })
    setTeamData({ teamData, note: "" })
    setMultiProductData({ ...multiProductData, note: "" })
    setMultiTeamData({ ...multiTeamData, note: "" })
    setUploadModalInput([])
    setAttachmentModalFile([])
    setMultiProductFile([])
    setMultiTeamFile([])
    setAttachFileLength("")
    setAttachFileName("")
    setFileLength("")
    setFileName("")
    setProductFileLength("")
    setProductFileName("")
    setTeamFileLength("")
    setTeamFileName("")
    setOperationAttachment([])
    setProcessData({
      ...processData, notes: ""
    })
    setOperationStatus([])
    setPlEmployee([])
  }

  const [productAssignData, setProductAssignData] = useState("")
  const [teamAssignData, setTeamAssignData] = useState("")

  const [productAssignDetails, setProductAssignDetails] = useState([])
  const [productSubmitButton, setProductSubmitButton] = useState(false)

  const [teamAssignDetails, setTeamAssignDetails] = useState([])
  const [teamSubmitButton, setTeamSubmitButton] = useState(false)

  const [multiProductModal, setMultiProductModal] = useState(false)
  const [multiTeamModal, setMultiTeamModal] = useState(false)
  //special instruction modal
  const [instructionsModal, setInstructionsModal] = useState(false)
  const [instructionsDetails, setInstructionsDetails] = useState("")
  //assigned history modal
  const [historyModal, setHistoryModal] = useState(false)

  const [processData, setProcessData] = useState({
    notes: "",
  })
  const handleNotesChange = (e) => {
    setProcessData({ ...processData, [e.target.name]: e.target.value })
  }
  const [operationStatus, setOperationStatus] = useState([])
  const operationStatusOptions = [
    { label: "EW QC Completed", value: "PS42" },
    { label: "Client Changes", value: "PS45" },
    { label: "Client Rework", value: "PS40" },
    { label: "Shared to client", value: "PS46" },
  ]

  const [updateProcess, setUpdateProcess] = useState("")
  const [processStatusModal, setProcessStatusModal] = useState(false)

  const [tatModal, setTatModal] = useState(false)
  const [tatUpdate, setTatUpdate] = useState(false)
  const [tatView, setTatView] = useState(false)

  //tatmodal 
  const [tatData, setTatData] = useState({
    tatDate: "",
    link: "",
    remarks: "",
    deliverableQuantity: ""
  })

  const handleTatChange = (e) => {
    setTatData({
      ...tatData, [e.target.name]: e.target.value
    })
  }
  const [tatDetails, setTatDetails] = useState("")
  const [operationHistoryDetails, setOperationHistoryDetails] = useState("")
  const [processHistoryDetails, setProcessHistoryDetails] = useState("")
  //crm Attachment
  const [crmAttachmentModal, setCrmAttachmentModal] = useState(false)
  const [crmAttachmentsDetails, setCrmAttachmentsDetails] = useState("")
  let slNo = 0
  const videoTable = !isEmpty(video_details)
    ? video_details.data.map((data, index) => {
      slNo = slNo + 1
      const teamArray =
        !isEmpty(data.assignedTeamlead) &&
        data.assignedTeamlead.length > 0 &&
        data.assignedTeamlead
          .map((m) => {
            const empName = !isEmpty(m) ? `${m.empCode} - ${m.name}` : ""
            return empName
          })
          .filter(Boolean)
      const teamName = teamArray.length > 0 ? teamArray.join() : "--"
      const teamNameValue = teamArray.length > 0 ? teamArray.join(",") : ""
      const employeeArray =
        !isEmpty(data.assignedEmployee) &&
        data.assignedEmployee.length > 0 &&
        data.assignedEmployee
          .map((m) => {
            const empName = !isEmpty(m) ? `${m.empCode} - ${m.name}` : ""
            return empName
          })
          .filter(Boolean)
      const employeeName =
        employeeArray.length > 0 ? employeeArray.join() : ""
      const employeeNameValue =
        employeeArray.length > 0 ? employeeArray.join(",") : ""

      const colorCode =
        !isEmpty(recordsMetaData) &&
        recordsMetaData.processStatusOptions &&
        recordsMetaData.processStatusOptions.length > 0 &&
        recordsMetaData.processStatusOptions.find(
          (_) => _.value === data.productionProcessStatus
        ) &&
        recordsMetaData.processStatusOptions.find(
          (_) => _.value === data.productionProcessStatus
        ).colorCode
      const createdDate = moment(data.leadCreatedAt)
      const assignedDate = moment(data.assignedDate)
      const daysDifference =
        createdDate && assignedDate
          ? createdDate.isValid() && assignedDate.isValid()
            ? createdDate.diff(assignedDate, "days")
            : "--"
          : "--"
      const dayDiffValue = daysDifference !== "--" ? `${daysDifference}  days` : "--"
      //last status
      console.log(data.updatedOn, "checking")
      const currentDay = moment().startOf('day')
      const updateOn = data.updatedOn ? moment.utc(data.updatedOn).startOf('day') : ""
      const updateDifference = currentDay && updateOn
        ? updateOn.isValid() && currentDay.isValid()
          ? Math.ceil(currentDay.diff(updateOn, 'days', true))
          : '--'
        : '--'
      const lastStatusValue = updateDifference != "--" ? `${updateDifference} days` : "--"
      const cpRemarks = !isEmpty(data.clientProfileRemarks)
        ? data.clientProfileRemarks.replace(/[\r\n,.]/gm, "")
        : "--"
      return {
        _id: data.leadId,
        sNo: slNo,
        leadNo: data.leadNo,
        leadId: data.leadId,
        colorCode: colorCode,
        company: data.companyName,
        routeData: data,
        branch: data.branchName,
        assignedHistory: data.assignedHistory,
        //deliverable
        deliverableName:
          data.delivarbleName !== null ? data.deliverableName : "--",
        count:
          data.count !== null && data.sheetLength !== null
            ? data.count + "/" + data.sheetLength
            : "--",
        clientCode: data.clientCode ? data.clientCode : "--",
        clientName: data.clientName ? data.clientName : "--",
        clientProfile: data.clientProfileName ? data.clientProfileName : "--",
        productName: data.productName ? data.productName : "--",
        attachments: {
          fileName: "", // file name for the row
          fileLength: data.length, // number of files for the row
        },
        quantity: data.quantity ? data.quantity : "--",
        remarks: data.remarks ? data.remarks : "--",
        crmAttachments: data.crmAttachments ? data.crmAttachments : "",
        crmRemark: data.crmRemark ? data.crmRemark : "--",
        eventDate: !isEmpty(data.eventDetails)
          ? data.eventDetails
            .map((m) => moment(m.eventDate).format(dateFormat))
            .join()
          : "--",
        leadDeliverableId: data.leadDeliverableId
          ? data.leadDeliverableId
          : "",
        operationId: data.oprationId ? data.oprationId : "",
        event: !isEmpty(data.eventName)
          ? data.eventName.map((m) => m).join()
          : "--",
        leadDate: data.leadDate
          ? moment(data.leadDate).format(dateFormat)
          : "--",
        crmName: data.crmName ? data.crmName : "--",
        crmReferrenceAttachment: (
          <>
            <Button className=" btn btn-warning  position-relative fs-5">
              <i className="fas fa-laptop"></i>

              <Input
                type="file"
                name="uploadInput"
                accept="application/pdf, audio/mp3 , image/jpeg"
                // id="upload-btn"
                multiple
                onChange={(e) => uploadChange(e, index, data)}
                style={{
                  position: "absolute",
                  fontSize: "50px",
                  opacity: 0,
                  right: 0,
                  top: 0,
                }}
              />
              <span className="position-absolute top-0 start-100 translate-middle  badge bg-danger  rounded-circle">
                {fileData[index] ? fileData[index].fileLength : 0}
              </span>
            </Button>
            <div className="text-decoration-underline text-danger">
              {fileData[index] ? fileData[index].fileName : ""}
            </div>
          </>
        ),
        productLead: (
          <>
            <div className="d-flex flex-row align-items-center">
              <Button
                className="btn btn-info text-nowrap"
                onClick={() => {
                  setProductAssignModal(true)
                  handleClearModal()
                  setProductAssignData(data)
                  if (
                    !isEmpty(data.assignedTeamlead) &&
                    data.assignedTeamlead.length > 0
                  ) {
                    editProductAssign(data.assignedTeamlead)
                  }
                }}
              >
                {!isEmpty(data.assignedTeamlead) &&
                  data.assignedTeamlead.length > 0
                  ? teamNameValue
                  : "Assign Product Lead"}
              </Button>

              <div className="ms-auto ml-2">
                <Input
                  type="checkbox"
                  checked={productAssignDetails.some(
                    (item) => item.oprationId === data.oprationId
                  )}
                  style={{
                    width: "15px",
                    height: "15px",
                    marginLeft: "10px",
                  }}
                  onChange={(e) => {
                    if (
                      e.target.checked &&
                      !productAssignDetails.find(
                        (item) => item.oprationId === data.oprationId
                      ) &&
                      isEmpty(teamAssignDetails)
                    ) {
                      setProductAssignDetails([...productAssignDetails, data])
                    } else {
                      setProductAssignDetails(
                        productAssignDetails.filter(
                          (item) => item.oprationId !== data.oprationId
                        )
                      )
                    }
                    const anyChecked = productAssignDetails.some(
                      (item) => item.oprationId !== data.oprationId
                    )
                    setProductSubmitButton(anyChecked)
                  }}
                />
              </div>
            </div>
          </>
        ),
        team: (
          <>
            <div className="d-flex flex-row align-items-center">
              <Button
                className="btn btn-warning text-nowrap"
                onClick={() => {
                  setTeamAssignModal(true)
                  setTeamAssignData(data)
                  handleClearModal()
                  handleClearModal()
                  if (
                    !isEmpty(data.assignedEmployee) &&
                    data.assignedEmployee.length > 0
                  ) {
                    editTeamAssign(data.assignedEmployee)
                  }
                }}
              >
                {!isEmpty(data.assignedEmployee) &&
                  data.assignedEmployee.length > 0
                  ? employeeNameValue
                  : "Assign Team"}
              </Button>

              <div style={{ marginLeft: "10px" }}>
                <Input
                  type="checkbox"
                  checked={teamAssignDetails.some(
                    (item) => item.leadId === data.leadId
                  )}
                  style={{ width: "15px", height: "15px" }}
                  onChange={(e) => {
                    if (
                      e.target.checked &&
                      !teamAssignDetails.find(
                        (item) => item.oprationId === data.oprationId
                      ) &&
                      isEmpty(productAssignDetails)
                    ) {
                      setTeamAssignDetails([...teamAssignDetails, data])
                    } else {
                      setTeamAssignDetails(
                        teamAssignDetails.filter(
                          (item) => item.oprationId !== data.oprationId
                        )
                      )
                    }
                    const anyChecked = teamAssignDetails.some(
                      (item) => item.oprationId !== data.oprationId
                    )
                    setTeamSubmitButton(anyChecked)
                  }}
                />
              </div>
            </div>
          </>
        ),
        attachment: (
          <>
            <Button className=" btn btn-warning  position-relative fs-5">
              <i className="fas fa-laptop"></i>
              <Input
                type="file"
                name="attachmentFile"
                accept="application/pdf, audio/mp3 , image/jpeg"
                // id="upload-btn"
                multiple
                onChange={(e) => attachmentChange(e, index)}
                style={{
                  position: "absolute",
                  fontSize: "50px",
                  opacity: 0,
                  right: 0,
                  top: 0,
                }}
              />
              <span className="position-absolute top-0 start-100 translate-middle  badge bg-danger  rounded-circle">
                {attachmentData[index] ? attachmentData[index].fileLength : 0}
              </span>
            </Button>
            <div className="text-decoration-underline text-danger">
              {attachmentData[index] ? attachmentData[index].fileName : ""}
            </div>
          </>
        ),
        tatDate: data.tat
          ? moment(data.tat).format(dateFormat)
          : "--",
        paymentStatus: data.paymentStatus ? data.paymentStatus : "--",
        specialInstructions: data.specialInstruction
          ? data.specialInstruction
          : "--",
        allowOrder: data.allowOrder ? data.allowOrder : "--",
        clearance: data.clearance ? data.clearance : "--",
        productLeadName: teamName ? teamName : "--",
        teamDetails: employeeName ? employeeName : "--",
        qcStatus: data.qcStatus ? data.qcStatus : "--",
        link: data.link ? data.link : "--",
        operationStatus: data.productionProcessStatusName,
        operationStatusId: data.productionProcessStatus,
        brideName: data.brideName ? data.brideName : "--",
        groomName: data.groomName ? data.groomName : "--",
        overallStatus: data.overAllStatus ? data.overAllStatus : "--",
        operationHistory: !isEmpty(data.operationalHistory) ? data.operationalHistory : [],
        processHistory: !isEmpty(data.processHistory) ? data.processHistory : [],
        subStatus: data.subStatus ? data.subStatus : "--",
        deliverableQuantity: data.deliverableQuantity ? data.deliverableQuantity : "--",
        cpStatus: data.clientProfileStatus && data.clientProfileStatus != null
          ? data.clientProfileStatus
          : "--",
        cpRemarks: cpRemarks,
        aging: data.deliverableAge ? `${data.deliverableAge}  days` : dayDiffValue,
        assignedDate: !isEmpty(data.assignedDate) ? moment(data.assignedDate).format(dateFormat) : "--",
        lastStatus: lastStatusValue,

      }
    })
    : []
  //Edit Team employee
  const editTeamAssign = (data) => {
    const teamEmployeeDetails = !isEmpty(data)
      ? data.map((team) => {
        return {
          label: team.empCode.concat("-", team.name),
          value: team._id,
        }
      })
      : []
    setTeamEmployee(teamEmployeeDetails)
  }

  //Edit product lead
  const editProductAssign = (data) => {
    const productDetails = !isEmpty(data)
      ? data.map((team) => {
        return {
          label: team.empCode.concat("-", team.name),
          value: team._id,
        }
      })
      : []
    setEmployee(productDetails)
  }
  useEffect(() => {
    if (productAssignDetails.length > 0) {
      setProductSubmitButton(true)
    } else {
      setProductSubmitButton(false)
    }
  }, [productAssignDetails])

  useEffect(() => {
    if (teamAssignDetails.length > 0) {
      setTeamSubmitButton(true)
    } else {
      setTeamSubmitButton(false)
    }
  }, [teamAssignDetails])

  const assignHistory = (data) => {
    const historyPayload = {
      operationId: data.operationId,
      deliverableId: data.leadDeliverableId,
      mode: "PRE"
    }
    setHistoryModal(true)
    setTimeout(() => {
      dispatch(saveVideoAction.loadProductionAssignHistory(historyPayload))
    }, 500)
  }
  const historyUpdate = useSelector((state) => state.savethevideo)

  const { history_details = [] } = historyUpdate
  const initialColumns = [
    {
      dataField: "sNo",
      text: "S.No",
      hidden: false,
      editable: false,
    },

    {
      dataField: "leadNo",
      text: "Lead Number",
      editable: false,
      hidden: false,
      formatter: (cellContent, row) => {
        const routeData = row.routeData
        return (
          <>
            {" "}
            <Link
              to={{
                pathname: `/client-details/${row._id}`,
                state: { row: routeData, mode: "EC" },
              }}
            >
              <span>{row.leadNo}</span>
            </Link>
          </>
        )
      },
      style: {
        color: "#E40D8C",
      },

      headerStyle: {
        minWidth: "130px",
      },
    },

    {
      dataField: "company",
      text: "Company",
      editable: false,
      hidden: true,
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "branch",
      text: "Branch",
      //sort: true,
      editable: false,
      hidden: true,
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "deliverableName",
      text: "Deliverable Name",
      hidden: true,
      editable: false,
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "clientCode",
      text: "Client Code",
      editable: false,
      hidden: false,
      headerStyle: {
        minWidth: "106px",
      },
    },

    {
      dataField: "clientName",
      text: "Client Name",
      editable: false,
      hidden: false,
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "cpRemarks",
      text: "CP Remarks",
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "cpStatus",
      text: "CP Status",
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "clientProfile",
      text: "Client Profile",
      editable: false,
      hidden: true,
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "groomName",
      text: "Groom Name",
      hidden: false,
      editable: false,
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "brideName",
      text: "Bride Name",
      hidden: false,
      editable: false,
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "crmName",
      text: "CRM Name",
      editable: false,
      hidden: false,
      csvExport: false,
      headerStyle: {
        minWidth: "120px",
      },
    },
    {
      dataField: "productLead",
      text: "Product Lead Name",
      editable: false,
      hidden: false,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "team",
      text: "Team Name",
      editable: false,
      hidden: false,
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "assignedDate",
      text: "Assigned Date",
      hidden: false,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "aging",
      text: "Aging",
      hidden: false,
      headerStyle: {
        minWidth: "160px",
      },
    },


    {
      dataField: "productName",
      text: "Product Name",
      hidden: false,
      editable: false,
      headerStyle: {
        minWidth: "128px",
      },
    },
    {
      dataField: "count",
      text: "Count/Sheet",
      hidden: false,
      editable: false,
      headerStyle: {
        minWidth: "120px",
      },
    },
    {
      dataField: "tatDate",
      text: "TAT Date",
      editable: false,
      hidden: false,
      headerStyle: {
        minWidth: "120px",
      },
    },
    {
      dataField: "link",
      text: "Deliverable link",
      editable: false,
      hidden: false,
      csvExport: true,
      headerStyle: {
        minWidth: "131px",
      },
    },
    {
      dataField: "deliverableQuantity",
      text: "Deliverable Quantity",
      hidden: false,
      editable: false,
      headerStyle: {
        minWidth: "168px",
      },
    },
    {
      dataField: "crmRemark",
      text: "Deliverable Remarks",
      editable: false,
      hidden: false,
      csvExport: true,
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "crmAttachments",
      text: "Deliverable Attachment",
      editable: false,
      hidden: false,
      formatter: (cellContent, row) => {
        const attachCount = !isEmpty(row.crmAttachments) && row.crmAttachments.length > 0 ?
          row.crmAttachments.length : 0
        return (
          <Row>
            <Col md="6" lg="6" sm="6">
              <div>
                {!isEmpty(row.crmAttachments) ? (
                  <a onClick={() => {
                    setCrmAttachmentModal(true)
                    setCrmAttachmentsDetails(row.crmAttachments)
                  }}>
                    <span
                      style={{
                        textDecoration: "underline",
                        color: "#E40D8C",
                      }}
                    >
                      View
                    </span>
                  </a>
                ) : (
                  "--"
                )}
              </div>
            </Col>
            <Col md="4" lg="4" sm="4">
              <div
                className="space-between"
              >
                <span className="badge rounded-pill bg-primary">
                  {attachCount}
                </span>

              </div>
            </Col></Row>
        )
      },
      csvExport: true,
      headerStyle: {
        minWidth: "185px",
      },
    },
    {
      dataField: "event",
      text: "Event Name",
      hidden: false,
      csvExport: false,
      editable: false,
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "specialInstructions",
      text: "Special Instructions",
      hidden: false,
      formatter: (cellContent, row) => {

        return (
          <div>
            <Button
              className="btn btn-info"
              onClick={() => {
                setInstructionsDetails(row.specialInstructions)
                setInstructionsModal(true)
              }}
            >
              Instructions
            </Button>
          </div>
        )
      },
      editable: false,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "assignedHistory",
      text: "Agent Assign History",
      editable: false,
      hidden: false,
      formatter: (cellContent, row) => {
        return (
          <div>
            <a
              onClick={() => {
                assignHistory(row)
              }}
            >
              <span
                style={{
                  textDecoration: "underline",
                  color: "#E40D8C",
                }}
              >
                History
              </span>
            </a>
          </div>
        )
      },
      csvExport: true,
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "quantity",
      text: "Quantity",
      hidden: true,
      editable: false,
      headerStyle: {
        minWidth: "140px",
      },
    },

    {
      dataField: "eventDate",
      text: "Event Date",
      hidden: true,
      editable: false,
      headerStyle: {
        minWidth: "130px",
      },
    },

    {
      dataField: "leadDate",
      text: "Lead Date",
      hidden: true,
      editable: false,
      headerStyle: {
        minWidth: "130px",
      },
    },

    {
      dataField: "remarks",
      text: "Remarks",
      hidden: true,
      editable: false,
      headerStyle: {
        minWidth: "130px",
      },
    },


    {
      dataField: "paymentStatus",
      text: "Payment Status",
      hidden: true,
      editable: false,
      headerStyle: {
        minWidth: "160px",
      },
    },

    {
      dataField: "allowOrder",
      text: "Allow Order",
      hidden: true,
      editable: false,
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "clearance",
      text: "Clearance",
      editable: false,
      hidden: true,
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "crmReferrenceAttachment",
      text: "CRM Referrence Attachment",
      editable: false,
      hidden: true,
      headerStyle: {
        minWidth: "200px",
      },
    },


    {
      dataField: "qcStatus",
      text: "QC Status",
      editable: false,
      hidden: true,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "attachment",
      text: "Attachment",
      hidden: true,
      editable: false,
      headerStyle: {
        minWidth: "160px",
      },
    },

    {
      dataField: "history",
      text: "Deliverable Update History",
      hidden: false,
      editable: false,
      formatter: (cellContent, row) => {
        return (

          <div className="d-flex flex-row align-items-center">
            <Button
              className="btn btn-warning"
              onClick={() => {
                setTatModal(true)
                setTatUpdate(true)
                setTatView(false)
                setTatDetails(row)
                setTatData({
                  ...tatData, tatDate: "", link: "", remarks: "", deliverableQuantity: ""
                })
                setTatAttachment([])
              }}
            >
              Update
            </Button>
            <div style={{ marginLeft: "10px" }}>
              <i
                className="fas fa-eye text-info fs-5"
                onClick={() => {
                  setTatModal(true)
                  setTatUpdate(false)
                  setTatView(true)
                  setOperationHistoryDetails(row.operationHistory)
                }}
              ></i>
            </div>
          </div>
        )
      },
      headerStyle: {
        minWidth: "205px",
      },
    },
    {
      dataField: "overallStatus",
      text: "Overall Status",
      editable: false,
      hidden: false,
      headerStyle: {
        minWidth: "125px",
      },
    },
    {
      dataField: "subStatus",
      text: "Sub Status",
      hidden: false,
      editable: false,
      headerStyle: {
        minWidth: "125px",
      },
    },
    {
      dataField: "lastStatus",
      text: "Last Status",
      hidden: false,
      editable: false,
      headerStyle: {
        minWidth: "155px",
      },
    },
    {
      dataField: "operationStatus",
      text: "Deliverable Status",
      hidden: false,
      editable: false,
      formatter: (cellContent, row) => {

        return (

          <Row>
            <Col md="8" lg="8" sm="8">
              {!isEmpty(row.operationStatus) ? (<button
                style={{
                  background: row.colorCode,
                  border: "none",
                  cursor: "pointer",
                  color: "white",
                  padding: "2px",
                  borderRadius: "4px",
                }}

              >
                {row.operationStatus}
              </button>) : ("--")}
            </Col>
            <Col md="2" lg="2" sm="2">
              <button
                style={{
                  background: "#17b77d",
                  border: "none",
                  cursor: "pointer",
                  color: "white",
                  padding: "4px 8px",
                  borderRadius: "3px",
                }}
                onClick={() => {
                  setUpdateProcess(row)
                  setProcessStatusModal(true)
                  handleClearModal()
                  setProcessHistoryDetails(row.processHistory)
                }}
              >
                <i
                  className="fas fa-edit icon-btn"
                  style={{ fontSize: "10px" }}
                ></i>
              </button>
            </Col>
          </Row>
        )
      },
      headerStyle: {
        minWidth: "160px",
      },
    },
  ]
  const [columns, setColumns] = useState(initialColumns)

  const [oddColumnData, setOddColumnData] = useState([])
  const [evenColumnData, setEvenColumnData] = useState([])
  useEffect(() => {
    if (columns && columns.length > 0) {
      var array = columns
      var evenColumns = []
      var oddColumns = []

      for (var i = 0; i < array.length; i++) {
        if (i % 2 === 0) {
          oddColumns.push(array[i])
        } else {
          evenColumns.push(array[i])
        }
      }

      setOddColumnData(oddColumns)
      setEvenColumnData(evenColumns)
    }
  }, [columns])


  const selectColumn = columns
    .filter((column) => column.hidden === false)
    .map((column) => column.dataField)

  const [selectedColumns, setSelectedColumns] = useState(selectColumn)

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target

    let updatedSelectedColumns
    if (checked) {
      updatedSelectedColumns = [...selectedColumns, value]
    } else {
      updatedSelectedColumns = selectedColumns.filter(
        (column) => column !== value
      )
    }

    setSelectedColumns(updatedSelectedColumns)
  }

  //  "Select All" checkbox
  const handleSelectAllChange = (e) => {
    const { checked } = e.target
    if (checked) {
      const allColumns = columns.map((column) => column.dataField)
      setSelectedColumns(allColumns)
    } else {
      const restoredColumns = initialColumns
        .filter((column) => !column.hidden)
        .map((column) => column.dataField)
      setSelectedColumns(restoredColumns)
    }
  }

  const handleSaveColumns = () => {
    setColumnModal(false)

    const updatedColumns = columns.map((column) => {
      const isColumnSelected = selectedColumns.includes(column.dataField)
      return { ...column, hidden: !isColumnSelected }
    })

    setColumns(updatedColumns)
    // default columns
    const defaultColumns = initialColumns.filter((column) => !column.hidden)
    const selectedNonDefaultColumns = selectedColumns.filter(
      (column) =>
        !defaultColumns.some(
          (defaultColumn) => defaultColumn.dataField === column
        )
    )

    if (selectedNonDefaultColumns.length > 0) {
      toast.success("New Columns added successfully!", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
    }
  }

  const handleRestoreToDefault = () => {
    const restoreColumns = initialColumns
      .filter((column) => !column.hidden)
      .map((column) => column.dataField)

    setSelectedColumns(restoreColumns)
  }

  const [loading, setLoading] = useState(false)

  //Search filter

  const handleClick = (e) => {
    e.preventDefault()
    setSearchFilter(true)
    dispatch(
      saveVideoAction.loadVideoDetails({
        searchFilter: searchInput,
        page: pageChange ? pageCount : 1,
        limit: 50,
        isOperation: true,
        // crmId: empId
      })
    )
    setTimeout(() => {
      setSearchFilter(false)
    }, 1200)
  }
  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType })

    const a = document.createElement("a")
    a.download = fileName
    a.href = window.URL.createObjectURL(blob)
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    })
    a.dispatchEvent(clickEvt)
    a.remove()
  }

  const exportToCsv = () => {
   
    var searchLeadNo = videoData && videoData ? videoData.leadNo : ""

    var searchEvent = event && event ? event.value : ""
    var searchFromDate =
      videoData && videoData.eventFromDate
        ? moment(videoData.eventFromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      videoData && videoData.eventToDate
        ? moment(videoData.eventToDate).format("YYYY-MM-DD")
        : ""
    
    var searchAssignedFromDate =
      videoData && videoData.assignedFromDate
        ? moment(videoData.assignedFromDate).format("YYYY-MM-DD")
        : ""
    var searchAssignedToDate =
      videoData && videoData.assignedToDate
        ? moment(videoData.assignedToDate).format("YYYY-MM-DD")
        : ""
    var searchGroom = videoData && videoData.groomName
      ? videoData.groomName
      : ""
    var searchBride = videoData && videoData.brideName
      ? videoData.brideName
      : ""
    var searchEwName = !isEmpty(ewName) ? [ewName.value] : ""
    var searchDeliverable = !isEmpty(deliverableStatus)
      ? deliverables
      : ""
    var searchvalue = {}

    searchvalue.isOperation = true

    if (searchLeadNo) {
      searchvalue.leadNo = searchLeadNo
    }
    if (searchEvent) {
      searchvalue.eventNameId = searchEvent
    }
    if (searchFromDate) {
      searchvalue.eventStartDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.eventEndDate = searchToDate
    }
    if (searchAssignedFromDate) {
      searchvalue.assignedFromDate = searchAssignedFromDate
    }
    if (searchAssignedToDate) {
      searchvalue.assignedToDate = searchAssignedToDate
    }
    if (searchGroom) {
      searchvalue.groomName = searchGroom
    }
    if (searchBride) {
      searchvalue.brideName = searchBride
    }
    if (searchEwName) {
      searchvalue.assignedEmployeeId = searchEwName
    }
    if (searchDeliverable) {
      searchvalue.productionprocessstatus = searchDeliverable
    }
    setPageLoad(!pageLoad)
    setDownloadLoading(true)
    api
      .post(`/get_qutation_delivareble_video_excel_export`, searchvalue)
      .then((response) => {
        const videoExportDataTable = !isEmpty(response.data.data)
          ? response.data.data.map((data, index) => {

            const eventNameList = !isEmpty(data.eventName)
              ? data.eventName.map((m) => m).join(",")
              : "--"
            const eventName = JSON.stringify(eventNameList).replace(
              /","/g,
              "\n"
            )
            const teamArray =
              !isEmpty(data.assignedTeamlead) &&
              data.assignedTeamlead.length > 0 &&
              data.assignedTeamlead
                .map((m) => {
                  const empName = !isEmpty(m) ? `${m.empCode} - ${m.name}` : ""
                  return empName
                })
                .filter(Boolean)
            const teamName = teamArray.length > 0 ? teamArray.join() : "--"
            const teamNameValue = JSON.stringify(teamName).replace(
              /","/g,
              "\n"
            )
            const employeeArray =
              !isEmpty(data.assignedEmployee) &&
              data.assignedEmployee.length > 0 &&
              data.assignedEmployee
                .map((m) => {
                  const empName = !isEmpty(m) ? `${m.empCode} - ${m.name}` : ""
                  return empName
                })
                .filter(Boolean)
            const employeeName =
              employeeArray.length > 0 ? employeeArray.join() : "--"
            const employeeNameValue = JSON.stringify(employeeName).replace(
              /","/g,
              "\n"
            )
            const groomName = JSON.stringify(data.groomName).replace(
              /","/g,
              "\n")
            const brideName = JSON.stringify(data.brideName).replace(
              /","/g,
              "\n"
            )

            const crmRemarks = JSON.stringify(data.crmRemark)
            const crmAttachments = !isEmpty(data.crmAttachments) && data.crmAttachments.length > 0 &&
              data.crmAttachments.map(m => m).filter(Boolean)
            const crmAttachmentsArray = crmAttachments.length > 0 ? crmAttachments.join() : "--"
            const crmAttachmentsValue = crmAttachmentsArray !== "--" ? JSON.stringify(crmAttachmentsArray).replace(
              /","/g,
              "\n"
            ) : "--"
            const count = data.count !== null && data.sheetLength !== null
              ? data.count + "/" + data.sheetLength
              : "--"
            const countValue = JSON.stringify(count)
            const createdDate = moment(data.leadCreatedAt)
            const assignedDate = moment(data.assignedDate)
            const daysDifference =
              createdDate && assignedDate
                ? createdDate.isValid() && assignedDate.isValid()
                  ? createdDate.diff(assignedDate, "days")
                  : "--"
                : "--"
            const dayDiffValue = daysDifference !== "--" ? `${daysDifference}  days` : "--"
            //last status
            console.log(data.updatedOn, "checking")
            const currentDay = moment().startOf('day')
            const updateOn = data.updatedOn ? moment.utc(data.updatedOn).startOf('day') : ""
            const updateDifference = currentDay && updateOn
              ? updateOn.isValid() && currentDay.isValid()
                ? Math.ceil(currentDay.diff(updateOn, 'days', true))
                : '--'
              : '--'
            const lastStatusValue = updateDifference != "--" ? `${updateDifference} days` : "--"
            const cpRemarks = !isEmpty(data.clientProfileRemarks)
              ? data.clientProfileRemarks.replace(/[\r\n,.]/gm, "")
              : "--"
            return {
              key: index,
              _id: data._id,
              sNo: index + 1,
              leadNo: data.leadNo,
              clientCode: data.clientCode ? data.clientCode : "--",
              clientName: data.clientName ? data.clientName : "--",
              groomName: groomName ? groomName : "--",
              brideName: brideName ? brideName : "--",
              crmName: data.crmName ? data.crmName : "--",
              productLeadName: teamName ? teamNameValue : "--",
              teamName: employeeName ? employeeNameValue : "--",
              productName: data.productName ? data.productName : "--",
              count: countValue,
              tatDate: data.tat ? moment(data.tat).format(dateFormat) : "--",
              link: data.link ? data.link : "--",
              crmRemark: crmRemarks ? crmRemarks : "--",
              crmAttachments: crmAttachmentsValue,
              event: eventName,
              overallStatus: data.overAllStatus ? data.overAllStatus : "--",
              operationStatus: data.productionProcessStatus ?
                data.productionProcessStatus : "--",
              cpStatus: data.clientProfileStatus && data.clientProfileStatus != null
                ? data.clientProfileStatus
                : "--",
              cpRemarks: cpRemarks,
              aging: data.deliverableAge ? `${data.deliverableAge}  days` : dayDiffValue,
              assignedDate: !isEmpty(data.assignedDate) ? moment(data.assignedDate).format(dateFormat) : "--",
              lastStatus: lastStatusValue,
            }
          })
          : []
        setTimeout(() => {
          let headerData = [
            "SNo,Lead No,  Client Code ,Client Name,CP Remarks,CP Status, Groom Name,Bride Name,Crm Name,Product Lead Name, Team Name,Assigned Date,Aging,Product Name,Count/Sheet,Tat Date,Deliverable Link,Deliverable Remarks,Deliverable Attachment,Event Name,Overall Status,Last Status,Deliverable Status",
          ]

          let usersCsv =
            !isEmpty(videoExportDataTable) &&
            videoExportDataTable.reduce((acc, user) => {
              const {
                sNo,
                leadNo,
                clientCode,
                clientName,
                cpRemarks,
                cpStatus,
                groomName,
                brideName,
                crmName,
                productLeadName,
                teamName,
                assignedDate,
                aging,
                productName,
                count,
                tatDate,
                link,
                crmRemark,
                crmAttachments,
                event,
                overallStatus,
                lastStatus,
                operationStatus
              } = user
              acc.push([
                sNo,
                leadNo,
                clientCode,
                clientName,
                cpRemarks,
                cpStatus,
                groomName,
                brideName,
                crmName,
                productLeadName,
                teamName,
                assignedDate,
                aging,
                productName,
                count,
                tatDate,
                link,
                crmRemark,
                crmAttachments,
                event,
                overallStatus,
                lastStatus,
                operationStatus
              ])

              return acc
            }, [])
          downloadFile({
            data: [...headerData, ...usersCsv].join("\n"),
            fileName: "saveTheVideo.csv",
            fileType: "text/csv",
          })
          setDownloadLoading(false)
        }, 500)
        return response.data
      })
      .catch((error) => {
        Promise.reject(error)
        setDownloadLoading(false)
      })

  }

  // remote pagination
  const RemotePagination = ({
    data,
    page,
    // sort,
    sizePerPage,
    onTableChange,
    totalSize,
  }) => (
    <div>
      <PaginationProvider
        pagination={paginationFactory({
          custom: true,
          page,
          // sort,
          sizePerPage,
          totalSize,
        })}
      >
        {({ paginationProps, paginationTableProps }) => (
          <div>
            <ToolkitProvider
              keyField="_id"
              data={data}
              columns={columns}
              search
              exportCSV
            >
              {() => (
                <div>
                  <Col md="12" xl="12" lg="12" sm="12" xs="12">
                    <Row className="d-flex flex-row">
                      <Col className="mb-3" md="4"></Col>
                      <Col
                        md="8"
                        style={{ marginBottom: "20px", marginTop: "-41px" }}
                      >
                        <div
                          style={{
                            float: "right",
                          }}
                        >
                          <Button
                            className="btn btn-info"
                            onClick={() => setColumnModal(true)}
                          >
                            Edit Columns
                          </Button>
                        </div>
                        <div
                          style={{
                            float: "right",
                            marginRight: "10px",
                          }}
                        >
                          {productSubmitButton ? (
                            <Button
                              className="btn btn-success text-nowrap"
                              onClick={() => {
                                setMultiProductModal(true)
                                handleClearModal()
                              }}
                              style={{
                                marginRight: "10px",
                              }}
                            >
                              Product Lead Assign
                            </Button>
                          ) : (
                            ""
                          )}
                          {teamSubmitButton ? (
                            <Button
                              className="btn btn-danger text-nowrap"
                              onClick={() => {
                                setMultiTeamModal(true)
                                handleClearModal()
                              }}
                              style={{
                                marginRight: "10px",
                              }}
                            >
                              Team Assign
                            </Button>
                          ) : (
                            ""
                          )}
                          <Button
                            className="btn btn-primary"
                            onClick={exportToCsv}
                            id="download"
                            style={{
                              backgroundColor: "#e40d8c",
                              color: "white",
                              border: "none",
                            }}
                          >
                            Download
                          </Button>
                        </div>
                      </Col>

                      <Col>
                        <BootstrapTable
                          remote
                          noDataIndication={"No Data Found..."}
                          keyField="_id"
                          data={data}
                          id="ImportTable"
                          columns={columns}
                          responsive
                          striped={true}
                          bordered={true}
                          onTableChange={onTableChange}
                          {...paginationTableProps}
                        />
                      </Col>
                    </Row>
                    <Row
                      style={{ marginTop: "5px" }}
                      className="align-items-md-center mt-30"
                    >
                      <Col className="inner-custom-pagination d-flex">
                        <div className="d-inline d-flex flex-row">
                          <SizePerPageDropdownStandalone {...paginationProps} />
                          <div
                            style={{
                              fontSize: "14px",
                              marginTop: "8px",
                              marginLeft: "4px",
                            }}
                          >
                            <PaginationTotalStandalone {...paginationProps} />
                          </div>
                        </div>
                        <div
                          className="text-md-right ms-auto"
                          style={{ zIndex: 0 }}
                        >
                          <PaginationListStandalone

                            {...paginationProps}
                          />
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </div>
              )}
            </ToolkitProvider>
          </div>
        )}
      </PaginationProvider>
    </div>
  )
  const [pageLoad, setPageLoad] = useState(false)
  const [state, setState] = useState({
    sizePerPage: 50,
    page: 1,
    totalSize: video_details.length,
    data:
      !isEmpty(video_details) && video_details.length > 0
        ? video_details.slice(0, 50)
        : [],
  })
  const { sizePerPage, page } = state

  //Table Change

  const handleTableChange = (
    type,
    { page, sortField, sortOrder, currentIndex, sizePerPage }
  ) => {
    setPageCount(page)
    setPageChange(true)
    setPageLoad(!pageLoad)
    let result =
      !isEmpty(video_details) && video_details.length > 0 ? video_details : []
    if (
      !isEmpty(event) ||
      !isEmpty(videoData.leadNo) ||
      !isEmpty(videoData.eventFromDate) ||
      !isEmpty(videoData.eventToDate)||
      !isEmpty(deliverableStatus) ||
      !isEmpty(videoData.assignedFromDate) ||
      !isEmpty(videoData.assignedToDate) ||
      !isEmpty(videoData.ewName) ||
      !isEmpty(videoData.brideName) ||
      !isEmpty(videoData.groomName) 
    ) {
     
      var searchLeadNo = videoData && videoData ? videoData.leadNo : ""

      var searchEvent = event && event ? event.value : ""
      var searchFromDate =
        videoData && videoData.eventFromDate
          ? moment(videoData.eventFromDate).format("YYYY-MM-DD")
          : ""
      var searchToDate =
        videoData && videoData.eventToDate
          ? moment(videoData.eventToDate).format("YYYY-MM-DD")
          : ""
      var searchAssignedFromDate =
        videoData && videoData.assignedFromDate
          ? moment(videoData.assignedFromDate).format("YYYY-MM-DD")
          : ""
      var searchAssignedToDate =
        videoData && videoData.assignedToDate
          ? moment(videoData.assignedToDate).format("YYYY-MM-DD")
          : ""
      var searchGroom = videoData && videoData.groomName
        ? videoData.groomName
        : ""
      var searchBride = videoData && videoData.brideName
        ? videoData.brideName
        : ""
      var searchEwName = !isEmpty(ewName) ? [ewName.value] : ""
      var searchDeliverable = !isEmpty(deliverableStatus)
        ? deliverables
        : ""
      var searchvalue = {}
      searchvalue.page = page
      searchvalue.limit = sizePerPage ? sizePerPage : 50
      searchvalue.isOperation = true
      // searchvalue.crmId = empId
     
      if (searchLeadNo) {
        searchvalue.leadNo = searchLeadNo
      }
      if (searchEvent) {
        searchvalue.eventNameId = searchEvent
      }
      if (searchFromDate) {
        searchvalue.eventFromDate = searchFromDate
      }
      if (searchToDate) {
        searchvalue.eventToDate = searchToDate
      }
      if (searchAssignedFromDate) {
        searchvalue.assignedFromDate = searchAssignedFromDate
      }
      if (searchAssignedToDate) {
        searchvalue.assignedToDate = searchAssignedToDate
      }
      if (searchGroom) {
        searchvalue.groomName = searchGroom
      }
      if (searchBride) {
        searchvalue.brideName = searchBride
      }
      if (searchEwName) {
        searchvalue.assignedEmployeeId = searchEwName
      }
      if (searchDeliverable) {
        searchvalue.productionprocessstatus = searchDeliverable
      }
      setPageLoad(!pageLoad)
      setLoading(true)
      dispatch(saveVideoAction.loadVideoDetails(searchvalue))
    } else {
      dispatch(
        saveVideoAction.loadVideoDetails({
          page: page,
          limit: sizePerPage,
          // crmId: empId,
          isOperation: true,
        })
      )
      setLoading(true)
      setPageLoad(!pageLoad)
    }
    // setPageCount(page)
    setTimeout(() => {
      setLoading(false)
    }, 2000)
    if (sortOrder === "asc") {
      result = result.sort((a, b) => {
        if (a[sortField] > b[sortField]) {
          return 1
        } else if (b[sortField] > a[sortField]) {
          return -1
        }
        return 0
      })
    } else {
      result = result.sort((a, b) => {
        if (a[sortField] > b[sortField]) {
          return -1
        } else if (b[sortField] > a[sortField]) {
          return 1
        }
        return 0
      })
    }

    setState(() => ({
      page,
      data: result.slice(currentIndex, currentIndex + sizePerPage),
      totalSize: result.length,
      sizePerPage,
    }))
  }


  const employeeValue = employee && employee.map((m) => m.value)

  const productSubmit = () => {
    const product_details = {
      menuMode: 2,
      employeeId: employeeValue,
      notes: productData.notes,
      attachments: attachmentModalFile,
      leadAssignDetail: [
        {
          leadId: productAssignData.leadId,
          leadDelivarableId: productAssignData.leadDeliverableId,
          leadEventId: productAssignData.eventId,
        },
      ],
    }
    dispatch(saveVideoAction.addProductAssign(product_details))
    setTimeout(() => {
      dispatch(
        saveVideoAction.loadVideoDetails(searchValue)
      )
      toast.success("Product Lead Assigned successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
    }, 1000)
  }
  const multipleProductEmployee =
    multiProductEmployee && multiProductEmployee.map((m) => m.value)

  const multiProductSubmit = () => {
    const productdata = {
      menuMode: 2,
      employeeId: multipleProductEmployee,
      notes: productData.notes,
      attachments: multiProductFile,
      leadAssignDetail: productAssignDetails.map((data) => {
        return {
          leadId: data.leadId,
          leadDelivarableId: data.leadDeliverableId,
          leadEventId: data.eventId,
        }
      }),
    }
    dispatch(saveVideoAction.addMultipleProductAssign(productdata))
    setTimeout(() => {
      dispatch(
        saveVideoAction.loadVideoDetails(searchValue)
      )
      setProductAssignDetails([])
      toast.success("Product Lead Assigned successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
      setMultiProductModal(false)
    }, 1000)
  }
  const teamEmployeeValue = teamEmployee && teamEmployee.map((m) => m.value)

  const teamSubmit = () => {
    const team_details = {
      leadAssignDetail: [
        {
          leadId: teamAssignData.leadId,
          leadDelivarableId: teamAssignData.leadDeliverableId,
          leadEventId: teamAssignData.eventId,
        },
      ],
      menuMode: 2,
      employeeId: teamEmployeeValue,
      notes: teamData.note,
      attachments: uploadModalInput,
      assignedBy: empId,
    }
    dispatch(saveVideoAction.addTeamAssign(team_details))
    setTimeout(() => {
      dispatch(
        saveVideoAction.loadVideoDetails(searchValue)
      )
      toast.success("Team Lead Assigned successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
    }, 1000)
  }

  const teamMultipleEmployee =
    multiTeamEmployee && multiTeamEmployee.map((m) => m.value)
  const teamMultipleSubmit = () => {
    const teamDetails = {
      menuMode: 2,
      employeeId: teamMultipleEmployee,
      notes: multiTeamData.note,
      attachments: multiTeamFile,
      assignedBy: empId,
      leadAssignDetail: teamAssignDetails.map((data) => {
        return {
          leadId: data.leadId,
          leadDelivarableId: data.leadDeliverableId,
          leadEventId: data.eventId,
        }
      }),
    }
    dispatch(saveVideoAction.addMultipleTeamAssign(teamDetails))
    setTimeout(() => {
      dispatch(
        saveVideoAction.loadVideoDetails(searchValue)
      )
      setTeamAssignDetails([])
      toast.success("Team Lead Assigned successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
      setMultiTeamModal(false)
    }, 1000)
  }

  const [uploadModalInput, setUploadModalInput] = useState([])
  const [fileName, setFileName] = useState("")
  const [fileLength, setFileLength] = useState("")

  const uploadModalChange = async (e) => {
    if (e.target.files) {
      setUploadModalInput(e.target.files)
      var file = e.target.files
      setFileName(file[0].name)
      setFileLength(file.length)
      var fileArrayDetails = Array.from(file)
      var teamUploadValue = uploadModalInput

      for (let x in fileArrayDetails) {
        const formData = new FormData()
        formData.append("file", fileArrayDetails[x])
        api.post("/image_upload", formData).then(async (res) => {
          if (res && res.data && res.data.data) {
            teamUploadValue.push(res.data.data)
            await setUploadModalInput(teamUploadValue)
          }
        })
      }
    }
  }
  const [attachmentModalFile, setAttachmentModalFile] = useState([])
  const [attachFileName, setAttachFileName] = useState("")
  const [attachFileLength, setAttachFileLength] = useState("")
  const productUploadChange = async (e) => {
    if (e.target.files) {
      setAttachmentModalFile(e.target.files)
      var file = e.target.files
      setAttachFileName(file[0].name)
      setAttachFileLength(file.length)
      var fileArrayDetails = Array.from(file)
      var teamUploadValue = attachmentModalFile

      for (let x in fileArrayDetails) {
        const formData = new FormData()
        formData.append("file", fileArrayDetails[x])
        api.post("/image_upload", formData).then(async (res) => {
          if (res && res.data && res.data.data) {
            teamUploadValue.push(res.data.data)
            await setAttachmentModalFile(teamUploadValue)
          }
        })
      }
    }
  }

  const [multiProductFile, setMultiProductFile] = useState([])
  const [productFileName, setProductFileName] = useState("")
  const [productFileLength, setProductFileLength] = useState("")
  const multiProductChange = async (e) => {
    if (e.target.files) {
      setMultiProductFile(e.target.files)
      var file = e.target.files
      setProductFileName(file[0].name)
      setProductFileLength(file.length)
      var fileArrayDetails = Array.from(file)
      var teamUploadValue = multiProductFile

      for (let x in fileArrayDetails) {
        const formData = new FormData()
        formData.append("file", fileArrayDetails[x])
        api.post("/image_upload", formData).then(async (res) => {
          if (res && res.data && res.data.data) {
            teamUploadValue.push(res.data.data)
            await setMultiProductFile(teamUploadValue)
          }
        })
      }
    }
  }
  const [multiTeamFile, setMultiTeamFile] = useState([])
  const [teamFileName, setTeamFileName] = useState("")
  const [teamFileLength, setTeamFileLength] = useState("")
  const multiTeamChange = async (e) => {
    if (e.target.files) {
      setMultiTeamFile(e.target.files)
      var file = e.target.files
      setTeamFileName(file[0].name)
      setTeamFileLength(file.length)
      var fileArrayDetails = Array.from(file)
      var teamUploadValue = multiTeamFile

      for (let x in fileArrayDetails) {
        const formData = new FormData()
        formData.append("file", fileArrayDetails[x])
        api.post("/image_upload", formData).then(async (res) => {
          if (res && res.data && res.data.data) {
            teamUploadValue.push(res.data.data)
            await setMultiTeamFile(teamUploadValue)
          }
        })
      }
    }
  }
  const [operationAttachment, setOperationAttachment] = useState([])

  const operationAttachmentChange = async (e) => {
    if (e.target.files) {
      var file = e.target.files
      var fileArrayDetails = Array.from(file)
      setOperationAttachment(file)
      var teamUploadValue = operationAttachment

      for (let x in fileArrayDetails) {
        const formData = new FormData()
        formData.append("file", fileArrayDetails[x])
        api.post("/image_upload", formData).then(async (res) => {
          if (res && res.data && res.data.data) {
            teamUploadValue.push(res.data.data)
            await setOperationAttachment(teamUploadValue)
          }
        })
      }
    }
  }
  const plEmployeeValue = !isEmpty(plEmployee)?plEmployee.map(m=>m.value):[]
  const printSubmit = (e) => {
    e.preventDefault()
    const print_details = {
      notes: processData.notes,
      attachments: operationAttachment,
      employeeId:plEmployeeValue,
      printPlAssignDetail: [
        {
          leadId: updateProcess.leadId,
          operationId: updateProcess.operationId
        }
      ]
    }
    dispatch(printAction.assignPrintPl(print_details))

  }
  const processSubmit = (e) => {
    e.preventDefault()
    const submitStatus = {
      operationId: updateProcess.operationId,
      mode: "CRM",
      productionprocessstatus: operationStatus.value,
      notes: processData.notes,
      attachment: operationAttachment
    }
    dispatch(saveVideoAction.updateProcess(submitStatus))
    setTimeout(() => {
      dispatch(saveVideoAction.loadVideoDetails(searchValue))
      setProcessStatusModal(false)
      toast.success("Process Status Updated successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
    }, 1000)

  }
  const [tatAttachment, setTatAttachment] = useState([])

  const tatAttachmentChange = async (e) => {
    if (e.target.files) {
      var file = e.target.files
      var fileArrayDetails = Array.from(file)
      setTatAttachment(file)
      var teamUploadValue = tatAttachment

      for (let x in fileArrayDetails) {
        const formData = new FormData()
        formData.append("file", fileArrayDetails[x])
        api.post("/image_upload", formData).then(async (res) => {
          if (res && res.data && res.data.data) {
            teamUploadValue.push(res.data.data)
            await setTatAttachment(teamUploadValue)
          }
        })
      }
    }
  }
  const historySubmit = () => {
    const tat_details = {
      productionId: tatDetails.operationId,
      deliverableId: tatDetails.leadDeliverableId,
      quantity: !isEmpty(tatData.deliverableQuantity) ? tatData.deliverableQuantity : "",
      tat: !isEmpty(tatData.tatDate) ? tatData.tatDate : "",
      link: !isEmpty(tatData.link) ? tatData.link : "",
      crmRemark: !isEmpty(tatData.remarks) ? tatData.remarks : "",
      crmAttachments: !isEmpty(tatAttachment) && tatAttachment.length > 0
        ? tatAttachment : [],
    }

    dispatch(saveVideoAction.addTat(tat_details))
    setTatModal(false)
    setTimeout(() => {
      dispatch(saveVideoAction.loadVideoDetails(searchValue))
      toast.success("CRM Deliverable Updated successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
    }, 1000)
  }
  return (
    <div className="page-content">
      <MetaTags>
        <title>{title} | Zero Gravity CRM</title>
      </MetaTags>
      <Container fluid>
        <Breadcrumbs title={"Operation"} breadcrumbItem={title} />
        <Row>
          <Col xs={12}>
            <Card>
              <CardBody>
                <form>
                  <Row>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"} htmlFor={"Lead No"}>
                          {"Lead No"}
                        </Label>
                      </div>
                      <Input
                        type="text"
                        name="leadNo"
                        value={videoData.leadNo}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter Lead No"
                      />
                    </Col>
                    

                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label
                          className={"form-label"}
                          htmlFor={"Event From Date"}
                        >
                          {"Event From Date"}
                        </Label>
                      </div>
                      <Input
                        type="date"
                        name="eventFromDate"
                        value={videoData.eventFromDate}
                        max={videoData.eventToDate}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter "
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label
                          className={"form-label"}
                          htmlFor={"Event To Date"}
                        >
                          {"Event To Date"}
                        </Label>
                      </div>
                      <Input
                        type="date"
                        name="eventToDate"
                        value={videoData.eventToDate}
                        min={videoData.eventFromDate}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter "
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <Label className="employee-label">Event</Label>
                      <Select
                        type="text"
                        name="event"
                        value={event}
                        onChange={(e) => setEvent(e)}
                        options={
                          recordsMetaData ? recordsMetaData.eventOptions : []
                        }
                        placeholder="Select Event"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                  
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"} htmlFor={"EW Name"}>
                          {"EW Name"}
                        </Label>
                      </div>
                      <ReactSearchAutocomplete
                        name="agent"
                        key={agentKey}
                        items={recordsMetaData.employeeOptions}
                        value={ewName}
                        type="autoComplete"
                        resultStringKeyName="label"
                        showIcon={false}
                        onSelect={(e) => setEwName(e)}
                        onChange={(e) => setEwName(e.target.value)}
                        onClear={() => setEwName([])}
                        placeholder="Enter EW Name"
                        fuseOptions={fuseAgentOptions} // Search on both fields
                        styling={{
                          height: "34px",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          backgroundColor: "white",
                          boxShadow: "none",
                          hoverBackgroundColor: "#E40D8C",
                          color: "black",
                          fontSize: "12px",
                          fontFamily: "Courier",
                          iconColor: "green",
                          clearIconMargin: "3px 8px 0 0",
                          zIndex: 10,
                        }}
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label
                          className="form-label"
                          htmlFor={"Assigned From Date"}
                        >
                          {"EW Assigned From Date"}
                        </Label>
                      </div>
                      <Input
                        type="date"
                        placeholder="Select Date"
                        name="assignedFromDate"
                        value={videoData.assignedFromDate}
                        max={videoData.assignedToDate}
                        onChange={(e) => handleChange(e)}
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label
                          className="form-label"
                          htmlFor={"Assigned To Date"}
                        >
                          {"EW Assigned To Date"}
                        </Label>
                      </div>
                      <Input
                        type="date"
                        placeholder="Select Date"
                        name="assignedToDate"
                        value={videoData.assignedToDate}
                        min={videoData.assignedFromDate}
                        onChange={(e) => handleChange(e)}
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"} htmlFor={"Bride Name"}>
                          {"Bride Name"}
                        </Label>
                      </div>

                      <Input
                        type="text"
                        name="brideName"
                        value={videoData.brideName}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter Bride Name"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"} htmlFor={"Groom Name"}>
                          {"Groom Name"}
                        </Label>
                      </div>

                      <Input
                        type="text"
                        name="groomName"
                        value={videoData.groomName}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter Groom Name"
                      />
                    </Col>

                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"}>
                          {"Deliverable Status"}
                        </Label>
                      </div>
                      <Select
                        type="text"
                        name="deliverableStatus"
                        value={deliverableStatus}
                        isMulti
                        onChange={(e) => setDeliverableStatus(e)}
                        options={
                          recordsMetaData ? recordsMetaData.deliverOptions : []
                        }
                        placeholder="Select Deliverable Status"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="12" md="12" sm="12" xs="12" className="mt-5">
                      <div
                        className="filter-buttons"
                        style={{ float: "right" }}
                      >
                        <Button
                          type="button"
                          className="btn btn-danger btn-label simple-form-Reset-btn mx-3"
                          onClick={() => {
                            resetForm()
                          }}
                        >
                          <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                          Reset
                        </Button>
                        <Button
                          type="submit"
                          onClick={(e) => handleFilter(e)}
                          className="btn btn-success btn-label simple-form-applyfilter-btn"
                        >
                          <i className="bx bx-filter-alt label-icon"></i>
                          {btnLoader && btnLoader ? (
                            <ButtonSpinner />
                          ) : (
                            "Apply Filter"
                          )}{" "}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col md="12" lg="12" xl="12">
            <Card>
              <CardBody>
                <div className="d-flex flex-row" style={{ marginTop: "20px" }}>
                  <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                    <form onSubmit={handleClick} className="d-flex flex-row">
                      <div style={searchBtnStyle || null}>
                        <Input
                          type="text"
                          name="searchInput"
                          value={searchInput}
                          onChange={(e) => setSearchInput(e.target.value)}
                          className="form-control"
                          placeholder="Search"
                          style={{ position: "relative" }}
                        />
                        <i
                          className="bx bx-search-alt"
                          style={{
                            position: "absolute",
                            top: "54px",
                            left: "41px",
                            fontSize: "13px",
                          }}
                        />
                      </div>
                      <button
                        className="btn btn-success mx-2"
                        type="submit"
                        style={{
                          background: searchFilter ? "#2ca67a" : "",
                          color: searchFilter ? "#ffffff" : "",
                        }}
                      >
                        <i className="fas fa-search"></i>
                      </button>
                    </form>
                  </div>
                </div>{" "}
                <RemotePagination
                  data={videoTable}
                  page={page}
                  sizePerPage={sizePerPage}
                  totalSize={!isEmpty(video_details)?video_details.totalDataCount:0}
                  onTableChange={handleTableChange}
                />
                {loading ? (
                  <Modal
                    show={loading}
                    style={{ width: "7%", margin: "18% 50%" }}
                  >
                    <Modal.Body>
                      <Spinner
                        as="span"
                        animation="grow"
                        size="lg"
                        role="status"
                        aria-hidden="true"
                        variant="success"
                        className="mx-2"
                        color="success"
                      />
                      {/* <span>Loading...</span> */}
                    </Modal.Body>
                  </Modal>
                ) : (
                  ""
                )}
                {btnLoading ? (
                  <Modal
                    show={btnLoading}
                    style={{ width: "7%", margin: "18% 50%" }}
                  >
                    <Modal.Body>
                      <Spinner
                        as="span"
                        animation="grow"
                        size="lg"
                        role="status"
                        aria-hidden="true"
                        variant="success"
                        className="mx-2"
                        color="success"
                      />
                      {/* <span>Loading...</span> */}
                    </Modal.Body>
                  </Modal>
                ) : (
                  ""
                )}
                {downloadLoading ? (
                  <Modal
                    show={downloadLoading}
                    style={{ width: "7%", margin: "18% 50%" }}
                  >
                    <Modal.Body>
                      <Spinner
                        as="span"
                        animation="grow"
                        size="lg"
                        role="status"
                        aria-hidden="true"
                        variant="success"
                        className="mx-2"
                        color="success"
                      />
                      {/* <span>Loading...</span> */}
                    </Modal.Body>
                  </Modal>
                ) : (
                  ""
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      {columnModal && (
        <Modal size="xl" show={columnModal}>
          <Modal.Header
            style={{
              backgroundColor: "white",
              color: "black",
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            Edit Columns
            <span>
              <i
                className="fa fa-times quote-close"
                aria-hidden="true"
                onClick={() => setColumnModal(false)}
              ></i>
            </span>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <div>
                <Input
                  type="checkbox"
                  checked={selectedColumns.length === columns.length}
                  onChange={(e) => handleSelectAllChange(e)}
                  style={{ width: "15px", height: "15px" }}
                />
                <Label style={{ fontSize: "16px", marginLeft: "10px" }}>
                  Select All
                </Label>
              </div>
            </Row>
            <Row>
              <Col sm="12" md="6" lg="6" className="ml-4">
                {oddColumnData.map((column) => (
                  <div key={column.dataField} className="d-flex flex-row">
                    <div className="form-check form-check-inline">
                      <Input
                        type="checkbox"
                        value={column.dataField}
                        checked={selectedColumns.includes(column.dataField)}
                        onChange={(e) => handleCheckboxChange(e)}
                        style={{ width: "15px", height: "15px" }}
                      />
                      <Label style={{ fontSize: "16px", marginLeft: "10px" }}>
                        {column.text}
                      </Label>
                    </div>
                  </div>
                ))}
              </Col>
              <Col sm="12" md="6" lg="6">
                {evenColumnData.map((column) => (
                  <div key={column.dataField} className="d-flex flex-row">
                    <div className="form-check form-check-inline">
                      <Input
                        type="checkbox"
                        value={column.dataField}
                        checked={selectedColumns.includes(column.dataField)}
                        onChange={(e) => handleCheckboxChange(e)}
                        style={{ width: "15px", height: "15px" }}
                      />
                      <Label style={{ fontSize: "16px", marginLeft: "10px" }}>
                        {column.text}
                      </Label>
                    </div>
                  </div>
                ))}
              </Col>
            </Row>
          </Modal.Body>

          <Modal.Footer>
            <p
              className="text-decoration-underline text-info"
              // onClick={() => {
              //   handleRestoreToDefault()

              // }}
              style={{ cursor: "pointer", fontSize: "16px" }}
              onClick={handleRestoreToDefault}
            >
              Restore To Default
            </p>
            <Button
              variant="secondary"
              className="btn btn-danger"
              data-bs-dismiss="modal"
              onClick={() => {
                setColumnModal(false)
                setSelectedColumns(selectColumn)
              }}
            >
              Close
            </Button>
            <Button
              variant="primary"
              className="btn btn-success"
              onClick={() => handleSaveColumns()}
            >
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {productAssignModal && (
        <Modal size="xl" show={productAssignModal}>
          <Modal.Header
            style={{
              backgroundColor: "#E40D8C",
              color: "white",
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            Product Lead
          </Modal.Header>
          <Modal.Body>
            <Row className="mb-5">
              <Col md="5" lg="5" xl="5" sm="12">
                <div className="d-flex justify-content-between">
                  <Label className="form-label" htmlFor={"Follow-Up-Date"}>
                    {"Employee"}
                  </Label>
                </div>

                <Select
                  isMulti
                  type="text"
                  name="employee"
                  value={employee}
                  onChange={(e) => setEmployee(e)}
                  options={
                    recordsMetaData ? recordsMetaData.employeeOptions : []
                  }
                  placeholder="Select Employee"
                  classNamePrefix="select2-selection"
                />
              </Col>

              <Col md="5" lg="5" xl="5" sm="12">
                <div className="d-flex justify-content-between">
                  <Label className={"form-label"} htmlFor={"Notes"}>
                    {"Notes"}
                  </Label>
                </div>
                <Input
                  type="textarea"
                  name="notes"
                  value={productData.notes}
                  onChange={(e) => handleNotes(e)}
                  placeholder="Enter Notes"
                />
              </Col>
              <Col lg="2" md="2" sm="12" xs="12">
                <div className="d-flex justify-content-between">
                  <Label className={"form-label"}>{"Attachment (JPG/PNG/PDF)"}</Label>
                </div>
                <Button className=" btn btn-warning  position-relative fs-5">
                  <i className="fas fa-laptop"></i>

                  <Input
                    type="file"
                    name="attachmentModalFile"
                    accept="application/pdf, audio/mp3 , image/jpeg"
                    // id="upload-btn"
                    multiple
                    onChange={(e) => productUploadChange(e)}
                    style={{
                      position: "absolute",
                      fontSize: "50px",
                      opacity: 0,
                      right: 0,
                      top: 0,
                    }}
                  />
                  <span className="position-absolute top-0 start-100 translate-middle  badge bg-danger  rounded-circle">
                    {attachFileLength ? attachFileLength : 0}
                  </span>
                </Button>
                <div className="text-decoration-underline text-danger">
                  {attachFileName ? attachFileName : ""}
                </div>
              </Col>
            </Row>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              className="btn btn-danger"
              data-bs-dismiss="modal"
              onClick={() => setProductAssignModal(false)}
            >
              Cancel
            </Button>
            <Button
              variant="secondary"
              className="btn btn-success"
              data-bs-dismiss="modal"
              onClick={() => {
                setProductAssignModal(false)
                productSubmit()
              }}
            >
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {teamAssignModal && (
        <Modal size="xl" show={teamAssignModal}>
          <Modal.Header
            style={{
              backgroundColor: "#E40D8C",
              color: "white",
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            Team
          </Modal.Header>
          <Modal.Body>
            <Row className="mb-5">
              <Col md="5" lg="5" xl="5" sm="12">
                <div className="d-flex justify-content-between">
                  <Label className="form-label" htmlFor={"Follow-Up-Date"}>
                    {"Employee"}
                  </Label>
                </div>

                <Select
                  isMulti
                  type="text"
                  name="teamEmployee"
                  value={teamEmployee}
                  onChange={(e) => setTeamEmployee(e)}
                  options={
                    recordsMetaData ? recordsMetaData.employeeOptions : []
                  }
                  placeholder="Select Employee"
                  classNamePrefix="select2-selection"
                />
              </Col>
              <Col md="5" lg="5" xl="5" sm="12">
                <div className="d-flex justify-content-between">
                  <Label className={"form-label"} htmlFor={"Notes"}>
                    {"Notes"}
                  </Label>
                </div>
                <Input
                  type="textarea"
                  name="note"
                  value={teamData.note}
                  onChange={(e) => handleTeam(e)}
                  placeholder="Enter Notes"
                />
              </Col>
              <Col lg="2" md="2" sm="12" xs="12">
                <div className="d-flex justify-content-between">
                  <Label className={"form-label"}>{"Attachment (JPG/PNG/PDF)"}</Label>
                </div>
                <Button className=" btn btn-warning  position-relative fs-5">
                  <i className="fas fa-laptop"></i>

                  <Input
                    type="file"
                    name="uploadModalInput"
                    accept="application/pdf, audio/mp3 , image/jpeg"
                    // id="upload-btn"
                    multiple
                    onChange={(e) => uploadModalChange(e)}
                    style={{
                      position: "absolute",
                      fontSize: "50px",
                      opacity: 0,
                      right: 0,
                      top: 0,
                    }}
                  />
                  <span className="position-absolute top-0 start-100 translate-middle  badge bg-danger  rounded-circle">
                    {fileLength ? fileLength : 0}
                  </span>
                </Button>
                <div className="text-decoration-underline text-danger">
                  {fileName ? fileName : ""}
                </div>
              </Col>
            </Row>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              className="btn btn-danger"
              data-bs-dismiss="modal"
              onClick={() => setTeamAssignModal(false)}
            >
              Cancel
            </Button>
            <Button
              variant="secondary"
              className="btn btn-success"
              data-bs-dismiss="modal"
              onClick={() => {
                setTeamAssignModal(false)
                teamSubmit()
              }}
            >
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {multiProductModal && (
        <Modal size="xl" show={multiProductModal}>
          <Modal.Header
            style={{
              backgroundColor: "#E40D8C",
              color: "white",
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            Product Lead
          </Modal.Header>
          <Modal.Body>
            <Row className="mb-5">
              <Col md="5" lg="5" xl="5" sm="12">
                <div className="d-flex justify-content-between">
                  <Label className="form-label" htmlFor={"Follow-Up-Date"}>
                    {"Employee"}
                  </Label>
                </div>

                <Select
                  isMulti
                  type="text"
                  name="multiProductEmployee"
                  value={multiProductEmployee}
                  onChange={(e) => setMultiProductEmployee(e)}
                  options={
                    recordsMetaData ? recordsMetaData.employeeOptions : []
                  }
                  placeholder="Select Employee"
                  classNamePrefix="select2-selection"
                />
              </Col>
              <Col md="5" lg="5" xl="5" sm="12">
                <div className="d-flex justify-content-between">
                  <Label className={"form-label"} htmlFor={"Notes"}>
                    {"Notes"}
                  </Label>
                </div>
                <Input
                  type="textarea"
                  name="note"
                  value={multiProductData.note}
                  onChange={(e) => handleMultiProduct(e)}
                  placeholder="Enter Notes"
                />
              </Col>
              <Col lg="2" md="2" sm="12" xs="12">
                <div className="d-flex justify-content-between">
                  <Label className={"form-label"}>{"Attachment (JPG/PNG/PDF)"}</Label>
                </div>
                <Button className=" btn btn-warning  position-relative fs-5">
                  <i className="fas fa-laptop"></i>

                  <Input
                    type="file"
                    name="multiProductFile"
                    accept="application/pdf, audio/mp3 , image/jpeg"
                    // id="upload-btn"
                    multiple
                    onChange={(e) => multiProductChange(e)}
                    style={{
                      position: "absolute",
                      fontSize: "50px",
                      opacity: 0,
                      right: 0,
                      top: 0,
                    }}
                  />
                  <span className="position-absolute top-0 start-100 translate-middle  badge bg-danger  rounded-circle">
                    {productFileLength ? productFileLength : 0}
                  </span>
                </Button>
                <div className="text-decoration-underline text-danger">
                  {productFileName ? productFileName : ""}
                </div>
              </Col>
            </Row>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              className="btn btn-danger"
              data-bs-dismiss="modal"
              onClick={() => {
                setMultiProductModal(false)
                setProductAssignDetails([])
              }}
            >
              Cancel
            </Button>
            <Button
              variant="secondary"
              className="btn btn-success"
              data-bs-dismiss="modal"
              onClick={() => {
                multiProductSubmit()
              }}
            >
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {multiTeamModal && (
        <Modal size="xl" show={multiTeamModal}>
          <Modal.Header
            style={{
              backgroundColor: "#E40D8C",
              color: "white",
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            Team
          </Modal.Header>
          <Modal.Body>
            <Row className="mb-5">
              <Col md="5" lg="5" xl="5" sm="12">
                <div className="d-flex justify-content-between">
                  <Label className="form-label" htmlFor={"Follow-Up-Date"}>
                    {"Employee"}
                  </Label>
                </div>

                <Select
                  isMulti
                  type="text"
                  name="multiTeamEmployee"
                  value={multiTeamEmployee}
                  onChange={(e) => setMultiTeamEmployee(e)}
                  options={
                    recordsMetaData ? recordsMetaData.employeeOptions : []
                  }
                  placeholder="Select Employee"
                  classNamePrefix="select2-selection"
                />
              </Col>
              <Col md="5" lg="5" xl="5" sm="12">
                <div className="d-flex justify-content-between">
                  <Label className={"form-label"} htmlFor={"Notes"}>
                    {"Notes"}
                  </Label>
                </div>
                <Input
                  type="textarea"
                  name="note"
                  value={multiTeamData.note}
                  onChange={(e) => handleMultiTeam(e)}
                  placeholder="Enter Notes"
                />
              </Col>
              <Col lg="2" md="2" sm="12" xs="12">
                <div className="d-flex justify-content-between">
                  <Label className={"form-label"}>{"Attachment (JPG/PNG/PDF)"}</Label>
                </div>
                <Button className=" btn btn-warning  position-relative fs-5">
                  <i className="fas fa-laptop"></i>

                  <Input
                    type="file"
                    name="multiTeamFile"
                    accept="application/pdf, audio/mp3 , image/jpeg"
                    // id="upload-btn"
                    multiple
                    onChange={(e) => multiTeamChange(e)}
                    style={{
                      position: "absolute",
                      fontSize: "50px",
                      opacity: 0,
                      right: 0,
                      top: 0,
                    }}
                  />
                  <span className="position-absolute top-0 start-100 translate-middle  badge bg-danger  rounded-circle">
                    {teamFileLength ? teamFileLength : 0}
                  </span>
                </Button>
                <div className="text-decoration-underline text-danger">
                  {teamFileName ? teamFileName : ""}
                </div>
              </Col>
            </Row>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              className="btn btn-danger"
              data-bs-dismiss="modal"
              onClick={() => {
                setMultiTeamModal(false)
                setTeamAssignDetails([])
              }}
            >
              Cancel
            </Button>
            <Button
              variant="secondary"
              className="btn btn-success"
              data-bs-dismiss="modal"
              onClick={() => {
                // setMultiTeamModal(false)
                teamMultipleSubmit()
              }}
            >
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {processStatusModal && (
        <Modal size="xl" show={processStatusModal}>
          <Modal.Header
            style={{
              backgroundColor: "#E40D8C",
              color: "white",
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            Deliverable Status
          </Modal.Header>
          <Modal.Body>
            <Row className="mb-2">

              <Col md="4" lg="4" xl="4" sm="12">
                <div className="d-flex justify-content-between">
                  <Label className="form-label" htmlFor={"Process Status"}>
                    {"Operation Status"}
                  </Label>
                </div>

                <Select
                  // isMulti
                  type="text"
                  name="operationStatus"
                  value={operationStatus}
                  onChange={(e) => setOperationStatus(e)}
                  options={operationStatusOptions}
                  placeholder="Select Operation Status"
                  classNamePrefix="select2-selection"
                />
              </Col>

              <Col md="4" lg="4" xl="4" sm="12">
                <div className="d-flex justify-content-between">
                  <Label className={"form-label"} htmlFor={"Notes"}>
                    {"Notes"}
                  </Label>
                </div>
                <Input
                  type="textarea"
                  name="notes"
                  value={processData.notes}
                  onChange={(e) => handleNotesChange(e)}
                  placeholder="Enter Notes"
                />
              </Col>
              <Col md="4" lg="4" xl="4" sm="12">
                <div className="d-flex justify-content-between">
                  <Label className={"form-label"} htmlFor={"Notes"}>
                    {"Attachment (JPG/PNG/PDF)"}
                  </Label>
                </div>
                <Input
                  type="file"
                  name="operationAttachment"
                  onChange={(e) => operationAttachmentChange(e)}
                  placeholder="Attach the files"
                  multiple
                />
              </Col>
              {operationStatus.value === "PS46" && (<Col md="4" lg="4" xl="4" sm="12">
                <div className="d-flex justify-content-between">
                  <Label className={"form-label"} htmlFor={"Notes"}>
                    {"Assign Print Pl"}
                  </Label>
                </div>
                <Select
                  type="text"
                  isMulti
                  name="plEmployee"
                  value={plEmployee}
                  onChange={(e) => setPlEmployee(e)}
                  options={recordsMetaData.employeeOptions}
                  placeholder="Select Assign Print Pl"
                  classNamePrefix="select2-selection"

                />
              </Col>)}
            </Row>
            <Row className="quote-head-content">
              <Col md="6" lg="6" sm="12">
                <p className="quote-head">
                  Process Status History
                </p>
              </Col></Row>
            <Row>
              <Table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Mode</th>
                    <th>Employee Name</th>
                    <th>Deliverable Status</th>
                    <th>Notes</th>
                    <th>Attachment</th>
                    <th>Created By</th>
                    <th>Created On</th>
                  </tr>
                </thead>
                <tbody>
                  {!isEmpty(processHistoryDetails) && processHistoryDetails.length > 0 ?
                    processHistoryDetails.map((data, index) => {
                      const processStatus = !isEmpty(recordsMetaData) &&
                        recordsMetaData.processStatusOptions &&
                        recordsMetaData.processStatusOptions.length > 0
                        ? recordsMetaData.processStatusOptions.find(
                          (_) => _.value === data.productionprocessstatus
                        )?.label
                        : "--"
                      const createdOn = !isEmpty(data.createdOn)
                        ? moment(data.createdOn)
                          .subtract(5, "hours")
                          .subtract(30, "minutes")
                          .format(`${dateFormat} ${"hh:mm A"}`)
                        : "--"
                      const empName = data.employeName && data.employeCode ? data.employeCode + "-" + data.employeName : "--"
                      const attachment = !isEmpty(data.attachment) ? data.attachment.map(m => m).join() : ""
                      const attachExtension = !isEmpty(attachment) ? attachment.split(".").pop() : ""
                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{data.mode ? data.mode : "--"}</td>
                          <td>{empName}</td>
                          <td>{processStatus}</td>
                          <td>{data.notes ? data.notes : "--"}</td>
                          <td> {(attachment && attachExtension === "jpeg") ||
                            (attachment && attachExtension === "jpg") ||
                            (attachment && attachExtension === "png") ? (
                            <a onClick={() => window.open(attachment, "_blank")}>
                              <span
                                style={{
                                  textDecoration: "underline",
                                  color: "#E40D8C",
                                }}
                              >
                                View
                              </span>
                            </a>
                          ) : (attachment && attachExtension === "mp3") ||
                            (attachment && attachExtension === "m4a") ||
                            (attachment && attachExtension === "mp4") ? (
                            <a href={attachment}>
                              <audio controls>
                                <source src={attachment} type="audio/mpeg" />
                                Your browser does not support the audio element.
                              </audio>
                            </a>
                          ) : (
                            "--"
                          )}</td>
                          <td>{data.createdByName ? data.createdByName : "--"}</td>
                          <td>{createdOn}</td>
                        </tr>
                      )
                    }) :
                    (<tr>
                      <td className="text-align-center" colSpan={8}>
                        No Records Found...
                      </td>
                    </tr>)}
                </tbody>
              </Table>
            </Row>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              className="btn btn-danger"
              data-bs-dismiss="modal"
              onClick={() => setProcessStatusModal(false)}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              variant="secondary"
              className={"btn btn-success"}
              data-bs-dismiss="modal"
              onClick={(e) => {
                if (operationStatus.value === "PS46" && !isEmpty(plEmployee)) {
                  printSubmit(e)
                  processSubmit(e)
                }
                else {
                  processSubmit(e)
                }
              }}
            >
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {instructionsModal && (
        <Modal size="xl" show={instructionsModal}>
          <Modal.Header
            style={{
              backgroundColor: "#E40D8C",
              color: "white",
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            Instructions
          </Modal.Header>
          <Modal.Body>
            <Row className="mt-3">
              <Table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Mode</th>
                    <th>Remarks</th>
                    <th>Created By</th>
                    <th>Created On</th>
                  </tr>
                </thead>
                <tbody>
                  {!isEmpty(instructionsDetails) &&
                    instructionsDetails.length > 0 ? (
                    instructionsDetails.map((data, index) => {
                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{data.mode}</td>
                          <td>{data.remarks}</td>
                          <td>{data.InsertByName}</td>
                          <td>{moment(data.createdAt).format(dateFormat)}</td>
                        </tr>
                      )
                    })
                  ) : (
                    <tr key={0}>
                      <td className="text-align-center" colSpan={5}>
                        No Records Found...
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </Row>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              className="btn btn-danger"
              data-bs-dismiss="modal"
              onClick={() => setInstructionsModal(false)}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {historyModal && (
        <Modal size="xl" show={historyModal}>
          <Modal.Header
            style={{
              backgroundColor: "#E40D8C",
              color: "white",
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            Assigned History
          </Modal.Header>
          <Modal.Body>
            <Row className="mt-3">
              <Table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Type</th>
                    <th>Employee Name</th>
                    <th>Notes</th>
                    <th>Attachment</th>
                    <th>Created On</th>
                    <th>Created By</th>
                  </tr>
                </thead>
                <tbody>
                  {!isEmpty(history_details) &&
                    history_details.data.length > 0 ? (
                    history_details.data.map((data, index) => {
                      const employeeName =
                        data.PrecrmId !== undefined && !isEmpty(data.PrecrmId)
                          ? data.PrecrmId.name
                          : data.assignedTeamlead !== undefined &&
                            !isEmpty(data.assignedTeamlead)
                            ? data.assignedTeamlead[0].employeeId
                              .map((employee) => employee.name)
                              .join()
                            : data.assignEmployee !== undefined &&
                              !isEmpty(data.assignEmployee)
                              ? data.assignEmployee[0].employeeId
                                .map((employee) => employee.name)
                                .join()
                              : data.assignCrmEmployee !== undefined &&
                                !isEmpty(data.assignCrmEmployee)
                                ? data.assignCrmEmployee[0].employeeId
                                  .map((employee) => employee.name)
                                  .join()
                                : "--"

                      const typeName = data.PrecrmId
                        ? "CRM"
                        : data.assignedTeamlead
                          ? "PL"
                          : data.assignCrmEmployee
                            ? "CRM"
                            : data.assignEmployee
                              ? "EW"
                              : "--"

                      const notesName =
                        data.PrecrmId !== undefined &&
                          !isEmpty(data.PrecrmId) &&
                          data.PrecrmId.notes
                          ? data.PrecrmId.notes
                          : data.assignedTeamlead !== undefined &&
                            !isEmpty(data.assignedTeamlead) &&
                            data.assignedTeamlead[0].notes !== ""
                            ? data.assignedTeamlead[0].notes
                            : data.assignEmployee !== undefined &&
                              !isEmpty(data.assignEmployee) &&
                              data.assignEmployee[0].notes !== ""
                              ? data.assignEmployee[0].notes
                              : data.assignCrmEmployee !== undefined &&
                                !isEmpty(data.assignCrmEmployee) &&
                                data.assignCrmEmployee[0].notes !== ""
                                ? data.assignCrmEmployee[0].notes
                                : "--"
                      const createdOn =
                        data.PrecrmId !== undefined &&
                          !isEmpty(data.PrecrmId) &&
                          data.PrecrmId.createdOn
                          ? moment.utc(data.PrecrmId.createdOn).format(`${dateFormat} ${"hh:mm A"}`)
                          : data.assignedTeamlead !== undefined &&
                            !isEmpty(data.assignedTeamlead)
                            ? moment.utc(data.assignedTeamlead[0].createdOn).format(`${dateFormat} ${"hh:mm A"}`)

                            : data.assignEmployee !== undefined &&
                              !isEmpty(data.assignEmployee)
                              ? moment.utc(data.assignEmployee[0].createdOn).format(`${dateFormat} ${"hh:mm A"}`)
                              : data.assignCrmEmployee !== undefined &&
                                !isEmpty(data.assignCrmEmployee)
                                ? moment.utc(data.assignCrmEmployee[0].createdOn).format(`${dateFormat} ${"hh:mm A"}`)
                                : "--"
                      const createdBy =
                        data.PrecrmId !== undefined && !isEmpty(data.PrecrmId)
                          ? data.PrecrmId.createdByName
                          : data.assignedTeamlead !== undefined && !isEmpty(data.assignedTeamlead)
                            ? data.assignedTeamlead[0].createdByName
                            : data.assignEmployee !== undefined && !isEmpty(data.assignEmployee)
                              ? data.assignEmployee[0].createdByName
                              : data.assignCrmEmployee !== undefined && !isEmpty(data.assignCrmEmployee)
                                ? data.assignCrmEmployee[0].createdByName
                                : '--'
                      const attachment = data.PrecrmId !== undefined && !isEmpty(data.PrecrmId)
                        ? data.PrecrmId.attachments
                        : data.assignedTeamlead !== undefined && !isEmpty(data.assignedTeamlead)
                          ? data.assignedTeamlead[0].attachments
                          : data.assignEmployee !== undefined && !isEmpty(data.assignEmployee)
                            ? data.assignEmployee[0].attachments
                            : data.assignCrmEmployee !== undefined && !isEmpty(data.assignCrmEmployee)
                              ? data.assignCrmEmployee[0].attachments
                              : '--'
                      const attachmentValue = !isEmpty(attachment) ? attachment[0] : []
                      const splitAttach = !isEmpty(attachmentValue)
                        ? attachmentValue.split(".")
                        : ""
                      const attachExtension = !isEmpty(splitAttach) ? splitAttach.pop() : ""
                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{typeName}</td>
                          <td>{employeeName}</td>
                          <td>{notesName}</td>
                          <td>
                            {(attachmentValue &&
                              (attachExtension === "jpeg" ||
                                attachExtension === "jpg" ||
                                attachExtension === "png")) ? (
                              <a onClick={() => window.open(attachmentValue, "_blank")}>
                                <span
                                  style={{
                                    textDecoration: "underline",
                                    color: "#E40D8C",
                                  }}
                                >
                                  View
                                </span>
                              </a>
                            ) : (attachmentValue &&
                              (attachExtension === "mp3" ||
                                attachExtension === "m4a" ||
                                attachExtension === "mp4")) ? (
                              <a href={attachmentValue}>
                                <audio controls>
                                  <source src={attachmentValue} type="audio/mpeg" />
                                  Your browser does not support the audio element.
                                </audio>
                              </a>
                            ) : attachmentValue && attachExtension === "pdf" ? (
                              <a href={attachmentValue} target="_blank" rel="noopener noreferrer">
                                <span
                                  style={{
                                    textDecoration: "underline",
                                    color: "#E40D8C",
                                  }}
                                >
                                  Open PDF
                                </span>
                              </a>
                            ) : (
                              "--"
                            )}
                          </td>
                          <td>{createdOn}</td>
                          <td>{createdBy}</td>
                        </tr>
                      )
                    })
                  ) : (
                    <tr key={0}>
                      <td className="text-align-center" colSpan={7}>
                        No Records Found...
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </Row>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              className="btn btn-danger"
              data-bs-dismiss="modal"
              onClick={() => setHistoryModal(false)}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {tatModal && (
        <Modal size="xl" show={tatModal}>
          <Modal.Header
            style={{
              backgroundColor: "#E40D8C",
              color: "white",
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            Deliverable Update History
          </Modal.Header>
          <Modal.Body>
            {tatUpdate && (
              <Row className="mb-5">
                <Col md="3" lg="3" xl="3" sm="12">
                  <div className="d-flex justify-content-between">
                    <Label className={"form-label"} htmlFor={"Date"}>
                      {"Tat Date"}
                    </Label>
                  </div>
                  <Input
                    type="date"
                    name="tatDate"
                    value={tatData.tatDate}
                    onChange={(e) => handleTatChange(e)}
                    placeholder="Enter Date"
                  />
                </Col>
                <Col md="3" lg="3" xl="3" sm="12">
                  <div className="d-flex justify-content-between">
                    <Label className={"form-label"} htmlFor={"link"}>
                      {"Link"}
                    </Label>
                  </div>
                  <Input
                    type="text"
                    name="link"
                    value={tatData.link}
                    onChange={(e) => handleTatChange(e)}
                    placeholder="Enter Link"
                  />
                </Col>
                <Col md="3" lg="3" xl="3" sm="12">
                  <div className="d-flex justify-content-between">
                    <Label className={"form-label"} htmlFor={"remarks"}>
                      {"Remarks"}
                    </Label>
                  </div>
                  <Input
                    type="textarea"
                    name="remarks"
                    value={tatData.remarks}
                    onChange={(e) => handleTatChange(e)}
                    placeholder="Enter Remarks"
                  />
                </Col>
                <Col md="3" lg="3" xl="3" sm="12">
                  <div className="d-flex justify-content-between">
                    <Label className={"form-label"} htmlFor={"Notes"}>
                      {"Attachment (JPG/PNG/PDF)"}
                    </Label>
                  </div>
                  <Input
                    type="file"
                    name="tatAttachment"
                    onChange={(e) => tatAttachmentChange(e)}
                    placeholder="Attach the files"
                    multiple
                  />
                </Col>
                <Col md="3" lg="3" xl="3" sm="12">
                  <div className="d-flex justify-content-between">
                    <Label className={"form-label"} htmlFor={"Deliverable Quantity"}>
                      {"Deliverable Quantity"}
                    </Label>
                  </div>
                  <Input
                    type="text"
                    name="deliverableQuantity"
                    value={tatData.deliverableQuantity}
                    onChange={(e) => handleTatChange(e)}
                    placeholder="Enter Deliverable quantity"
                  />
                </Col>
              </Row>
            )}
            {tatView && (
              <Row className="mt-3">
                <Table>
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Mode</th>
                      <th>Tat Date</th>
                      <th>Link</th>
                      <th>Remarks</th>
                      <th>Attachment</th>
                      <th>Quantity</th>
                      <th>Created By</th>
                      <th>Created On</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!isEmpty(operationHistoryDetails) &&
                      operationHistoryDetails.length > 0 ? (
                      operationHistoryDetails.map((data, index) => {
                        const tatDate = data.tat
                          ? moment(data.tat).format(dateFormat)
                          : "--"
                        const attachment = !isEmpty(data.attachment)
                          ? data.attachment.map((m) => m).join()
                          : ""

                        const attachExtension = !isEmpty(attachment)
                          ? attachment.split(".").pop()
                          : ""
                        const createdOn = !isEmpty(data.createdOn)
                          ? moment(data.createdOn)
                            .subtract(5, "hours")
                            .subtract(30, "minutes")
                            .format(`${dateFormat} ${"hh:mm A"}`)
                          : "--"
                        return (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{data.mode ? data.mode : "--"}</td>
                            <td>{tatDate}</td>
                            <td>{data.link ? data.link : "--"}</td>
                            <td>{data.remarks ? data.remarks : "--"}</td>
                            <td>
                              {" "}
                              {(attachment && attachExtension === "jpeg") ||
                                (attachment && attachExtension === "jpg") ||
                                (attachment && attachExtension === "png") ? (
                                <a
                                  onClick={() =>
                                    window.open(attachment, "_blank")
                                  }
                                >
                                  <span
                                    style={{
                                      textDecoration: "underline",
                                      color: "#E40D8C",
                                    }}
                                  >
                                    View
                                  </span>
                                </a>
                              ) : (attachment && attachExtension === "mp3") ||
                                (attachment && attachExtension === "m4a") ||
                                (attachment && attachExtension === "mp4") ? (
                                <a href={attachment}>
                                  <audio controls>
                                    <source
                                      src={attachment}
                                      type="audio/mpeg"
                                    />
                                    Your browser does not support the audio
                                    element.
                                  </audio>
                                </a>
                              ) : (
                                "--"
                              )}
                            </td>
                            <td>{data.quantity ? data.quantity : "--"}</td>
                            <td>
                              {data.createdByName ? data.createdByName : "--"}
                            </td>
                            <td>{createdOn}</td>
                          </tr>
                        )
                      })
                    ) : (
                      <tr>
                        <td className="text-align-center" colSpan={9}>
                          No Records Found...
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </Row>
            )}
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              className="btn btn-danger"
              data-bs-dismiss="modal"
              onClick={() => setTatModal(false)}
            >
              Cancel
            </Button>
            {tatUpdate ? (
              <Button
                type="submit"
                variant="secondary"
                className={"btn btn-success"}
                data-bs-dismiss="modal"
                onClick={(e) => historySubmit(e)}
              >
                update
              </Button>
            ) : (
              ""
            )}
          </Modal.Footer>
        </Modal>
      )}
      {crmAttachmentModal && (
        <Modal show={crmAttachmentModal} size="lg">
          <Modal.Header
            style={{
              backgroundColor: "#E40D8C",
              color: "white",
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            Deliverable Attachment
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col lg="12" md="12" sm="12" xs="12">
                <Table bordered>
                  <thead>
                    <tr>
                      <th>Sl.No</th>
                      <th>Attachments</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!isEmpty(crmAttachmentsDetails) &&
                      crmAttachmentsDetails.length > 0 ? (
                      crmAttachmentsDetails.map((item, index) => {
                        const splitAttach = !isEmpty(item)
                          ? item.split(".")
                          : ""
                        const attachExtension = !isEmpty(splitAttach)
                          ? splitAttach.pop()
                          : ""
                        return (
                          <>
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>
                                {" "}
                                {(item && attachExtension === "jpeg") ||
                                  (item && attachExtension === "jpg") ||
                                  (item && attachExtension === "png") ? (
                                  <a
                                    onClick={() => window.open(item, "_blank")}
                                  >
                                    <span
                                      style={{
                                        textDecoration: "underline",
                                        color: "#E40D8C",
                                      }}
                                    >
                                      View
                                    </span>
                                  </a>
                                ) : (item && attachExtension === "mp3") ||
                                  (item && attachExtension === "m4a") ||
                                  (item && attachExtension === "mp4") ? (
                                  <a href={item}>
                                    <audio controls>
                                      <source src={item} type="audio/mpeg" />
                                      Your browser does not support the audio
                                      element.
                                    </audio>
                                  </a>
                                ) : (
                                  ""
                                )}
                              </td>
                            </tr>
                          </>
                        )
                      })
                    ) : (
                      <>
                        <tr key={0}>
                          <td colSpan={2} className="text-align-center">
                            No record found
                          </td>
                        </tr>
                      </>
                    )}
                  </tbody>
                </Table>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              className="btn btn-danger"
              onClick={() => setCrmAttachmentModal(false)}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      <ToastContainer
        position="top-right"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  )
}
SaveTheVideoDetails.propTypes = {
  dispatch: PropTypes.func,
  recordsMetaData: PropTypes.array,
  searchProps: PropTypes.func,
  baseProps: PropTypes.any,
  searchBtnStyle: PropTypes.any,
  disableMultiSelect: PropTypes.any,
  csvProps: PropTypes.any,
  title: PropTypes.any,
  onSearch: PropTypes.func,
  onExport: PropTypes.func,
  pageClick: PropTypes.any,
  data: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  totalSize: PropTypes.number.isRequired,
  sizePerPage: PropTypes.number.isRequired,
  onTableChange: PropTypes.func.isRequired,
}
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({
  // employee: state.employeeRequest.employee,
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SaveTheVideoDetails)
)
